import React, { useCallback, useState, useEffect, useRef, createRef, useMemo } from 'react';
import {
   useColorModeValue,
   Card,
   Grid,
   GridItem,
   Button,
   CardBody,
   CardHeader,
   Heading,
   useToast,
   CardFooter,
   Flex,
   useDisclosure,
   Box,
   Table,
   Thead,
   Tbody,
   Tr,
   Th,
   Td,
   TableContainer,
   IconButton,
   Image,
   Text,
   Badge,
   Icon,
   Modal,
   ModalBody,
   ModalCloseButton,
   ModalHeader,
   ModalContent,
   ModalOverlay,
} from '@chakra-ui/react';
import { FaHistory } from 'react-icons/fa';
import { FaCircleInfo } from 'react-icons/fa6';
import * as Yup from 'yup';
import moment from 'moment';
import Swal from 'sweetalert2';
import _ from 'lodash';

// UI
// import LineItem from '../sales/Pages/SalesInvoiceMaster/LineItem';
import LineItem from 'components/LineItem';
import BillTerm from '../sales/Pages/SalesInvoiceMaster/BillTerm';
import TaxableAmount from '../sales/Pages/SalesInvoiceMaster/TaxableAmount';
import { renderDynamicDropdown } from 'components/UIcomponents/DynamicDropdown';
import { renderDynamicDropdown as dynamicDropdown } from 'components/ui/DynamicDropdown';
import InputField from 'components/ui/InputField';
import ExchangeModal from '../sales/Pages/SalesInvoiceMaster/ExchangeModal';
import SerialNumberModal from '../sales/Pages/SalesInvoiceMaster/SerialNumberModal';
import CustomerVerifyModal from '../purchase/Pages/PurchaseInvoiceMaster/CustomerVerifyModal';
import TextareaField from 'components/ui/TextareaField';
import { renderSwitchControl } from 'utils/DynamicFormData';
import PrintFormat from 'components/PrintFormate/PrintFormat';
import AccountSelect from 'components/AccountSelect/AccountSelect';
import TakaForm from '../purchase/Pages/PurchaseInvoiceMaster/TakaForm';
import SelectTakaDetail from '../purchase/Pages/PurchaseInvoiceMaster/SelectTakaDetail';
import { getSerialWiseHistory } from '../../../redux/actions/salesLineDetail';
import { getAdjustedDocs, uploadSalesDocument } from '../../../redux/actions/salesInvoice';
import { useParams, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

// contexts
import { useUser, useGlobal, useDaybook, useAccount, useItem, useBusinessType } from '../../../contexts';

// hooks
import useCalculateTaxAmount from 'hooks/useSalesTaxAmount';
import useSalesChallanLastDaybook from 'hooks/useSalesChallanLastDaybook';

// Actions
import { getStock } from '../../../redux/actions/salesLineDetail';
// import { getAccount, getAccountById, emptyAccount } from '../../../../../redux/actions/account';
import { getAccount } from '../../../redux/actions/account';
import { getPaymentDaybook, getDaybookById, getDaybook } from '../../../redux/actions/daybook';
import { getItem } from '../../../redux/actions/item';
import { getMainAndSubHsn } from '../../../redux/actions/mainAndSubHsn';
import { getWarehouse } from '../../../redux/actions/warehouse';
import { getGLGroupsAllDropdown } from '../../../redux/actions/glGroup';
import {
   emptySales,
   getPrevAndNext,
   // checkDocNo,
   getItemPrice,
} from '../../../redux/actions/salesInvoice';
import {
   getSaleChallan,
   addSaleChallan,
   updateSaleChallan,
   getSaleChallanById,
   checkDocNo,
   getOrderDocument
} from '../../../redux/actions/salesChallan';
import { deleteSalesLineItem } from '../../../redux/actions/salesLineItem';
import { getBillTerm } from '../../../redux/actions/billTerm';
import {
   generateEInvoice,
   generateEWayBill,
   cancelEInvoice,
   cancelEWayBill,
} from '../../../redux/actions/ewayBillAndeInvoice';
import { getTransport } from '../../../redux/actions/transport';
import { getVehicle } from '../../../redux/actions/vehicle';
import { getSetupFormat, setupFormatCustomQuery } from '../../../redux/actions/setupFormat';
import { getUsers } from '../../../redux/actions/user';
import { getFinancialYears } from '../../../redux/actions/dashboard';

// utils
import {
   getAccountAddress,
   getGstTaxType,
   getGstSubTaxType,
   eBillDateFormat,
   handlePrintClick,
   injectDataIntoHtml,
   getFirstErrorMessage,
   formatAmount,
   getGstRate,
} from 'utils/util';
import { SupplyTypes } from 'utils/dropdownEnum';

// icons
import { FaTrash } from 'react-icons/fa';

// image
import phone from 'assets/img/nfts/phone.svg';
import Email from 'assets/img/nfts/email.svg';
import map from 'assets/img/nfts/map.svg';
import panno from 'assets/img/nfts/panno.svg';
import gstno from 'assets/img/nfts/gstno.svg';
import Brokername from 'assets/img/nfts/Brokername.svg';
import Balance from 'assets/img/nfts/Balance.svg';
import back from 'assets/img/nfts/back.svg';

import DeleteDialog from '../masters/components/DeleteDialog';
import SalesDetails from 'components/salesDetails/SalesDetails';
import { getPurchaseInvoice } from '../../../redux/actions/purchaseInvoice';
import Loader from '../default/Loader';
import loaderAnimation from '../../../assets/img/auth/loding.gif';

const validationSchema = Yup.object().shape({
   header: Yup.object().shape({
      daybookId: Yup.number()
         .typeError('Daybook is required')
         .required('Daybook is required')
         .positive('Invalid daybook selected'),

      docno: Yup.string().required('Document number is required').trim(),

      transactionAt: Yup.date()
         .required('Transaction date is required'),

      accountId: Yup.number()
         .typeError('Account is required')
         .required('Account is required')
         .positive('Invalid account selected'),

      basicAmount: Yup.number()
         .required('Basic amount is required')
         .min(0, 'Basic amount cannot be negative')
         .test(
            'is-decimal',
            'Amount cannot have more than 2 decimal places',
            (value) => !value || Number.isInteger(value * 100),
         ),
      netAmount: Yup.number().required('Net amount is required'),
   }),

   lineItem: Yup.array()
      .required('Line items are required')
      .min(1, 'At least one line item is required')
      .of(
         Yup.object().shape({
            itemId: Yup.number()
               .typeError('Item is required')
               .required('Item is required')
               .positive('Invalid item selected'),
            itemRate: Yup.number().required('Item rate is required').min(0, 'Item rate cannot be negative'),

            qty1: Yup.number()
               .transform((value, originalValue) => {
                  return originalValue === '' || originalValue == null
                     ? 0
                     : value;
               })
               .required('Quantity is required')
               .when('processedQty1', (processedQty1, schema) => {
                  if (processedQty1 !== undefined && processedQty1 !== null) {
                     return schema.min(
                        processedQty1,
                        `Quantity 1 cannot be less than already processed quantity (${processedQty1})`
                     );
                  }
                  return schema.min(0, 'Quantity 1 cannot be negative');
               }),

            qty2: Yup.number()
               .transform((value, originalValue) => {
                  return originalValue === '' || originalValue == null
                     ? 0
                     : value;
               })
               .default(0)
               .when('processedQty2', (processedQty2, schema) => {
                  if (processedQty2 !== undefined && processedQty2 !== null) {
                     return schema.min(
                        processedQty2,
                        `Quantity 2 cannot be less than already processed quantity (${processedQty2})`
                     );
                  }
                  return schema.min(0, 'Quantity 2 cannot be negative');
               }),

            qty3: Yup.number()
               .transform((value, originalValue) => {
                  return originalValue === '' || originalValue == null
                     ? 0
                     : value;
               })
               .default(0)
               .when('processedQty3', (processedQty3, schema) => {
                  if (processedQty3 !== undefined && processedQty3 !== null) {
                     return schema.min(
                        processedQty3,
                        `Quantity 3 cannot be less than already processed quantity (${processedQty3})`
                     );
                  }
                  return schema.min(0, 'Quantity 3 cannot be negative');
               }),

            amount: Yup.number().required('Amount is required').min(0, 'Amount cannot be negative'),

            ratePer: Yup.number().min(0, 'Rate per cannot be negative'),

            uomNoForRate: Yup.number()
               .integer('UOM number must be a whole number')
               .min(0, 'UOM number cannot be negative'),
         }),
      ),
});

const SalesInvoiceForm = () => {
   const { isOpen: isOpenModal, onOpen: onOpenModal, onClose: onCloseModal } = useDisclosure();
   const { isOpen: isOpenExchangeModal, onOpen: onOpenExchangeModal, onClose: onCloseExchangeModal } = useDisclosure();
   const { isOpen: isOpenVerifyModal, onOpen: onOpenVerifyModal, onClose: onCloseVerifyModal } = useDisclosure();
   const { isOpen: isOpenDeleteModal, onOpen: onOpenDeleteModal, onClose: onCloseDeleteModal } = useDisclosure();
   const { isOpen: isOpenSerialhistory, onOpen: onOpenSerialhistory, onClose: onCloseSerialhistory } = useDisclosure();
   const { isOpen: isOpenAdjustedDocs, onOpen: onOpenAdjustedDocs, onClose: onCloseAdjustedDocs } = useDisclosure();
   const { isOpen: isOpenPrintFormatModal, onOpen: onOpenPrintFormatModal, onClose: onClosePrintFormatModal } = useDisclosure();
   const { isOpen: isOpenTakaModal, onOpen: onOpenTakaModal, onClose: onCloseTakaModal } = useDisclosure();
   const {
      isOpen: isOpenTakaDetailModal,
      onOpen: onOpenTakaDetailModal,
      onClose: onCloseTakaDetailModal,
   } = useDisclosure();
   const { lastSaleDaybook, setSelectedDaybookId: setDaybookId } = useSalesChallanLastDaybook();
   const { user } = useUser();
   const { companyList, company } = useGlobal();
   const { daybooks: allDaybook, salesChallanDaybooks: daybookData, paymentDaybooks } = useDaybook();
   const { accounts: accountData, incomeAccounts } = useAccount();
   const { items: itemData } = useItem();
   const { businessTypes } = useBusinessType();
   const initialLineItem = useMemo(() => {
      return {
         typeOfSupply: 1,
         headerId: 1,
         gst: 0,
         netGst: 0,
         gstAmount: 0,
         itemId: null,
         lineNumber: 1,
         itemRate: null,
         amount: 0,
         netAmount: 0,
         taxableAmount: 0,
         ratePer: 0,
         uomNoForRate: 0,
         salesprice1: 0,
         salesprice2: 0,
         salesprice3: 0,
         qty1: 0,
         qty2: 0,
         qty3: 0,
         hsnData: company?.hsndata,
         sacData: company?.sacdata,
         ratio: null,
         addLess1Percent: 0,
         addLess1Amount: 0,
         addLess2Percent: 0,
         addLess2Amount: 0,
         addLess3Percent: 0,
         addLess3Amount: 0,
         stock: [],
         takaDetails: [],
         unit: null,
         qUnitId1: null,
         qUnitId2: null,
         qUnitId3: null,
         subHSNId: null,
         warehouseId: null,
         isDeleted: false,
         notes: '',
         remarks: '',
         gstWithRate: null,
      };
   }, [company?.hsndata, company?.sacdata]);
   const [row, setRow] = useState({
      header: {
         daybookId: lastSaleDaybook?.daybookId || '',
         docno: '',
         transactionAt: new Date().toISOString().split('T')[0],
         companyId: '',
         accountId: '',
         brokerId: '',
         basicAmount: 0,
         additionAmount: '',
         deductionAmount: '',
         netAmount: 0,
         dueDays: 0,
         dueAt: new Date().toISOString().split('T')[0],
         billtoStateId: null,
         shiptoStateId: null,
         warehouseId: null,
         notes: '',
         vehicleId: null,
         transportId: null,
         representativeId: user?.id,
         incomeId: null,
      },
      lineItem: [initialLineItem],
   });


   // State
   const billTermData = useSelector((state) => state.billTerm?.list);
   const salesInvoice = useSelector((state) => state.salesChallan?.single);
   const stocks = useSelector((state) => state?.salesLineDetail?.stocks);
   const warehouse = useSelector((state) => state?.warehouse?.list);
   const selectedDaybook = useSelector((state) => state.daybook.single);
   const glGroup = useSelector((state) => state.glGroup?.ledger || []);
   const warehouseList = useSelector((state) => state.warehouse.list);
   const serialWiseHistory = useSelector((state) => state?.salesLineDetail?.serialhistory);
   const adjustedDocs = useSelector((state) => state?.salesChallan?.adjusted);
   const editExchangeData = useSelector((state) => state.salesChallan?.single?.exchange);
   const financialYears = useSelector((state) => state?.dashboard?.financialYears);
   const orderDocument = useSelector((state) => state?.salesChallan?.orderDocument);

   const daybookPaymentData = paymentDaybooks;
   const companyData = company;
   const targetGlGroup = glGroup?.find((group) => group.code === 'K');

   const filteredDaybooks = daybookData.filter((item) => item.type === 4);
   const daybookbalance = filteredDaybooks.find((item) => item.id === row?.header?.daybookId)?.bal ?? null;

   const selectdaybookdata = daybookData.find((daybook) => daybook.id === row.header.daybookId);
   const herderview =
      selectdaybookdata?.warehouseInId === 1
         ? true
         : selectdaybookdata?.warehouseInId === null
            ? companyData?.setting?.warehouseInSale === 1
               ? true
               : false
            : false;
   const lineitemview =
      selectdaybookdata?.warehouseInId === 2
         ? true
         : selectdaybookdata?.warehouseInId === null
            ? companyData?.setting?.warehouseInSale === 2
               ? true
               : false
            : false;
   const lineDetailview =
      selectdaybookdata?.warehouseInId === 3
         ? true
         : selectdaybookdata?.warehouseInId === null
            ? companyData?.setting?.warehouseInSale === 3
               ? true
               : false
            : false;

   const [data, setData] = useState([]);
   const [filedDisabled, setFiledDisabled] = useState(false);
   const [invoiceImages, setInvoiceImages] = useState([]);
   const [shouldFetch, setShouldFetch] = useState(false);
   const [selectedItem, setSelectedItem] = useState(null);
   const transportList = useSelector((state) => state.transport?.list);
   const vehicleList = useSelector((state) => state.vehicle?.list);
   const prints = useSelector((state) => state.setupPrint.list);
   const salesManList = useSelector((state) => state.users.users || []);
   const [salesData, setSalesData] = useState(null);
   const [showSalesDetails, setShowSalesDetails] = useState(false);
   const [savedSalesId, setSavedSalesId] = useState(null);
   const [orderDoc, setOrderDoc] = useState([]);
   const [shouldOpenModalForWpSettings, setShouldOpenModalForWpSettings] = useState(false);
   const { userGlobalSettingsData } = useGlobal();
   const shouldSendCompanyIdDaybook = userGlobalSettingsData?.[0]?.askCompany?.daybook || false;
   const shouldSendCompanyIdAccount = userGlobalSettingsData?.[0]?.askCompany?.account || false;
   const shouldSendCompanyIdItem = userGlobalSettingsData?.[0]?.askCompany?.item || false;
   const shouldSendCompanyIdWarehouse = userGlobalSettingsData?.[0]?.askCompany?.warehouse || false;
   const shouldSendCompanyIdVehicle = userGlobalSettingsData?.[0]?.askCompany?.vehicle || false;
   const shouldSendCompanyIdTransport = userGlobalSettingsData?.[0]?.askCompany?.transport || false;
   const shouldSendCompanyidBillTerm = userGlobalSettingsData?.[0]?.askCompany?.bllTerm || false;

   const [errors, setErrors] = useState({});
   const [billTerms, setBillTerms] = useState([]);
   const [stockList, setStockList] = useState([]);
   const [selectedStocks, setSelectedStocks] = useState([]);
   // const [selectedAccount, setSelectedAccount] = useState(null);
   // const [hasFetchedAccount, setHasFetchedAccount] = useState(false);
   const [deleteLineItemId, setDeleteLineItemId] = useState(null);
   const [isSameState, setIsSameState] = useState(null);
   const [paymentData, setPaymentData] = useState([]);
   const [exchangePayments, setExchangePayments] = useState([]);
   const [exchange, setExchange] = useState([]);
   const [voucher, setVoucher] = useState(null);
   const [isLoading, setIsLoading] = useState(false);
   const [currentLineItemIdx, setCurrentLineItemIdx] = useState(null);
   const [isEWayBill, setIsEWayBill] = useState(false);
   const [isEInvoice, setIsEInvoice] = useState(false);
   const [isPageLoading, setIsPageLoading] = useState(true);
   const [selectedDaybookData, setSelectedDaybookData] = useState(null);
   const [currentTakaDetails, setCurrentTakaDetails] = useState([]);
   const [takaDetails, setTakaDetails] = useState([]);
   const [selectedTakaDetails, setSelectedTakaDetails] = useState([]);
   const [currentIndex, setCurrentIndex] = useState(null);

   const { id } = useParams();
   const toast = useToast();
   const dispatch = useDispatch();
   const darkMode = useColorModeValue(false, true);
   const textColor = useColorModeValue('gray.800', 'white');
   const navigate = useNavigate();

   const newDaybookId =
      salesData && salesData.daybookId !== undefined && salesData.daybookId !== null ? salesData.daybookId : null;

   const shouldShowSalesDetails = newDaybookId === row.header.daybookId && salesData?.wpSetting === 0;

   const {
      totals,
      handleQtyChange,
      handleRateChange,
      handleDiscountChange,
      setTotalBillTermAmount,
      setBillTerm,
      finalNetAmount,
      handleItemChange,
      handleUnitChange,
   } = useCalculateTaxAmount({
      row,
      setRow,
      setBillTerms,
   });

   // get value in local storage
   const accountId = localStorage.getItem('accountId');
   const daybookId = localStorage.getItem('daybook');

   const lastClick = useRef(0);

   // refs
   const daybookRef = useRef(null);
   const docNoRef = useRef(null);
   const transactionAtRef = useRef(null);
   const accountRef = useRef(null);
   const incomeRef = useRef(null);
   const issueDocRef = useRef(null);
   const brokerRef = useRef(null);
   const dueDaysRef = useRef(null);
   const dueDateRef = useRef(null);
   const transportRef = useRef(null);
   const submitRef = useRef(null);
   const closeRef = useRef(null);
   const exchangeRef = useRef(null);
   const cancelewaybillRef = useRef(null);
   const generateewaybillRef = useRef(null);
   const canceleinvoiceRef = useRef(null);
   const geberateeinvoiceRef = useRef(null);
   const vehicleRef = useRef(null);
   const notesRef = useRef(null);
   const supplierRef = useRef(null);
   const wareHouseRef = useRef(null);
   const lineItemNotesRef = useRef(null);
   const lineItemRemarkRef = useRef(null);
   const orderDocRef = useRef(null);
   const warehouseRef = useRef([]);
   const itemRefs = useRef([]);
   const qty1Refs = useRef([]);
   const qty2Ref = useRef([]);
   const qty3Ref = useRef([]);
   const rateRefs = useRef([]);
   const gstRateRefs = useRef([]);
   const gstTaxableRefs = useRef([]);
   const percentageRefs = useRef([]);
   const amountRefs = useRef([]);
   const subamountRefs = useRef([]);
   const paymentRefs = useRef([]);
   const exchangeData = useRef({ exchanges: [], exchangePayments: [] });
   const refs = {
      warehouseRef,
      itemRefs,
      qty1Refs,
      qty2Ref,
      qty3Ref,
      rateRefs,
      percentageRefs,
      subamountRefs,
      amountRefs,
      dueDaysRef,
      lineItemNotesRef,
      lineItemRemarkRef,
      gstRateRefs,
      gstTaxableRefs,
   };

   const daybook = useMemo(() => {
      return daybookData?.filter((item) => item.type === 4).find((daybook) => daybook.id === row.header.daybookId);
   }, [daybookData, row.header.daybookId]);

   const pendingPayment = useMemo(() => {
      let badgeColor = 'blue.400';
      let borderColor = 'blue.400';

      if (id && salesInvoice?.pendingstatus === 'FULL PENDING') {
         badgeColor = 'orange.400';
         borderColor = 'orange.400';
      } else if (id && salesInvoice?.pendingstatus === 'CLEAR') {
         badgeColor = 'green.400';
         borderColor = 'green.400';
      } else if (id && salesInvoice?.pendingstatus === 'PART PENDING') {
         badgeColor = 'blue.400';
         borderColor = 'blue.400';
      }

      return { badgeColor, borderColor };
   }, [id, salesInvoice?.pendingstatus]);

   const account = useMemo(() => {
      return accountData.find((account) => account.id === row.header.accountId);
   }, [accountData, row.header.accountId]);

   const exchangeDaybook = useMemo(() => {
      return allDaybook?.find((daybook) => daybook.name.toUpperCase() === 'PURCHASE EXCHANGE');
   }, [allDaybook]);

   const vouchers = useMemo(() => salesInvoice?.vouchers ?? [], [salesInvoice?.vouchers]);

   const handleKeyDown = (e, nextRef, preRef) => {
      if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
         e.preventDefault();
         if (nextRef && nextRef?.current) {
            nextRef?.current?.focus();
         }
      }
      if (e.key === 'Tab' && e.shiftKey) {
         e.preventDefault();
         if (preRef && preRef?.current) {
            preRef?.current?.focus();
         }
      }
   };

   const prepareRowRefs = (count) => {
      warehouseRef.current = Array(count)
         .fill()
         .map((_, i) => warehouseRef.current[i] || createRef());

      itemRefs.current = Array(count)
         .fill()
         .map((_, i) => itemRefs.current[i] || createRef());

      qty1Refs.current = Array(count)
         .fill()
         .map((_, i) => qty1Refs.current[i] || createRef());

      rateRefs.current = Array(count)
         .fill()
         .map((_, i) => rateRefs.current[i] || createRef());

      gstRateRefs.current = Array(count)
         .fill()
         .map((_, i) => gstRateRefs.current[i] || createRef());

      gstTaxableRefs.current = Array(count)
         .fill()
         .map((_, i) => gstTaxableRefs.current[i] || createRef());
      lineItemNotesRef.current = Array(count)
         ?.fill()
         ?.map((_, i) => lineItemNotesRef?.current?.[i] || createRef());

      lineItemRemarkRef.current = Array(count)
         ?.fill()
         ?.map((_, i) => lineItemRemarkRef?.current?.[i] || createRef());
   };

   const prepareBillTermRowRefs = (count) => {
      percentageRefs.current = Array(count)
         .fill()
         .map((_, i) => percentageRefs.current[i] || createRef());

      amountRefs.current = Array(count)
         .fill()
         .map((_, i) => amountRefs.current[i] || createRef());
   };

   const preparePaymentRowRefs = (count) => {
      paymentRefs.current = Array(count)
         .fill()
         .map((_, i) => paymentRefs.current[i] || createRef());
   };

   const validateForm = useCallback(async () => {
      try {
         await validationSchema.validate(row, { abortEarly: false });
         setErrors({});
         return true;
      } catch (error) {
         if (error instanceof Yup.ValidationError) {
            const newErrors = {};
            error.inner.forEach((err) => {
               newErrors[err.path] = err.message;
            });
            setErrors(newErrors);
            return false;
         }
         return false;
      }
   }, [row]);

   const handleStockModalOnClick = useCallback(
      async (index) => {
         const lineItemData = row.lineItem[Number(index)];
         const selectedItem = itemData?.find((item) => item.id.toString() === lineItemData?.itemId?.toString());
         if (selectedItem?.itemdetailtype === 1) {
            if (user?.loginhistory?.companyId)
               await dispatch(
                  getStock({
                     itemId: Number(lineItemData?.itemId),
                     companyId: Number(user?.loginhistory?.companyId),
                     isReceiveStock: false,
                  }),
               );
            setStockList((prev) => prev.concat(lineItemData?.stock));
            onOpenModal();
         }
         if (
            daybook &&
            daybook?.getLineDetail &&
            selectedItem &&
            selectedItem?.id > 0 &&
            businessTypes?.businessType?.toUpperCase() === 'TEXTILE'
         ) {
            setCurrentIndex(index);
            setCurrentTakaDetails(row.lineItem[index]?.takaDetails || []);
            const itemLineData = row.lineItem[Number(index)];
            if (itemLineData?.issueLineId && itemLineData?.issueLineId > 0) {
               const takaDetails = itemLineData?.takaDetails?.map((i) => {
                  return { ...i };
               });
               setSelectedTakaDetails(takaDetails);
               setTakaDetails(takaDetails);
               onOpenTakaDetailModal();
            } else {
               onOpenTakaModal();
            }
         }
      },
      [dispatch, itemData, onOpenModal, row.lineItem, user?.loginhistory?.companyId, daybook, businessTypes?.businessType, onOpenTakaDetailModal, onOpenTakaModal],
   );

   const handleDaybook = async (name, value) => {
      const newRow = { ...row };

      setDaybookId(Number(value));
      await dispatch(
         getBillTerm({
            daybookId: Number(value),
            ...(shouldSendCompanyidBillTerm && { companyIds: user?.loginhistory?.companyId }),
         }),
      );

      newRow.header[name] = value;
      setRow(newRow);
      setErrors((prev) => {
         const obj = prev;
         const fullName = `header.${name}`;
         delete obj[fullName];
         return obj;
      });
   };

   const handleAccount = useCallback(
      async (name, value) => {
         if (name === 'accountId') {
            const newRow = { ...row };
            const id = typeof value === 'object' && value !== null ? value.id : value;

            newRow.header[name] = id;
            setRow(newRow);

            setErrors((prev) => {
               const obj = { ...prev };
               delete obj['header.accountId'];
               return obj;
            });
            if (daybook && daybook?.orderFieldRegion === 0 && value) {
               await dispatch(getOrderDocument({
                  accountId: value,
                  ...(daybook?.orderdaybookid && { daybookId: daybook?.orderdaybookid }),
                  ...(shouldSendCompanyIdAccount && { accountCompanyId: user?.loginhistory?.companyId, }),
                  ...(shouldSendCompanyIdItem && { itemCompanyId: user?.loginhistory?.companyId, }),
               }));
               if (value === salesInvoice?.accountId) {
                  setRow((prev) => ({
                     ...prev,
                     lineItem: [
                        ...(prev.lineItem || []).map((item) =>
                           item.isDeleted && item.poliId
                              ? { ...item, isDeleted: false }
                              : { ...item },
                        ),
                     ],
                  }));
               }
            } else if (daybook && daybook?.orderFieldRegion === 0) {
               setOrderDoc([]);
               await dispatch(getOrderDocument({
                  ...(daybook?.orderdaybookid && { daybookId: daybook?.orderdaybookid }),
                  ...(shouldSendCompanyIdAccount && { accountCompanyId: user?.loginhistory?.companyId, }),
                  ...(shouldSendCompanyIdItem && { itemCompanyId: user?.loginhistory?.companyId, }),
               }));
            }

            if (value === '' && daybook && daybook?.orderFieldRegion === 0) {
               setRow((prev) => ({
                  ...prev,
                  lineItem: [initialLineItem],
               }));
            }
         }

         if (name === 'warehouseId') {
            const newRow = { ...row };
            newRow.header[name] = value;
            newRow.lineItem = newRow.lineItem.map((item) => ({
               ...item,
               [name]: value,
               stock: Array.isArray(item.stock) && businessTypes?.businessType?.toUpperCase() === 'MOBILE'
                  ? item.stock.map((stockItem) => ({
                     ...stockItem,
                     [name]: stockItem.warehouseId ? stockItem.warehouseId : value,
                  }))
                  : [], // fallback if stock is not array
            }));
            setRow(newRow);
            setErrors((prev) => {
               const obj = prev;
               delete obj['header.brokerId'];
               return obj;
            });
         }

         if (name === 'brokerId') {
            const newRow = { ...row };
            newRow.header[name] = value;
            setRow(newRow);
            setErrors((prev) => {
               const obj = prev;
               delete obj['header.brokerId'];
               return obj;
            });
         }

         if (name === 'transportId') {
            const newRow = { ...row };
            newRow.header[name] = value;
            setRow(newRow);
            setErrors((prev) => {
               const obj = prev;
               delete obj['header.transportId'];
               return obj;
            });
         }

         if (name === 'vehicleId') {
            const newRow = { ...row };
            newRow.header[name] = value;
            setRow(newRow);
            setErrors((prev) => {
               const obj = prev;
               delete obj['header.vehicleId'];
               return obj;
            });
         }

         if (name === 'representativeId') {
            const newRow = { ...row };
            newRow.header[name] = value;
            setRow(newRow);
            setErrors((prev) => {
               const obj = prev;
               delete obj['header.representativeId'];
               return obj;
            });
         }

         if (name === 'incomeId') {
            const newRow = { ...row };
            newRow.header[name] = value;
            setRow(newRow);
            setErrors((prev) => {
               const obj = prev;
               delete obj['header.incomeId'];
               return obj;
            });
         }
      },
      [row],
   );

   const handleStockModal = useCallback(
      (itemId, index) => {
         const selectedItem = itemData?.find((item) => item.id.toString() === itemId.toString());
         if (selectedItem && selectedItem.itemdetailtype === 1) {
            onOpenModal();
         }
         if (
            daybook &&
            daybook?.getLineDetail &&
            selectedItem &&
            selectedItem?.id > 0 &&
            businessTypes?.businessType?.toUpperCase() === 'TEXTILE'
         ) {
            setCurrentIndex(index);
            setCurrentTakaDetails(row.lineItem[index]?.takaDetails || []);
            const itemLineData = row.lineItem[Number(index)];
            if (itemLineData?.issueLineId && daybook?.getLineDetail) {
               const takaDetails = itemLineData?.takaDetails?.map((i) => {
                  return { ...i };
               });
               setSelectedTakaDetails(takaDetails);
               setTakaDetails(takaDetails);
               onOpenTakaDetailModal();
            } else {
               onOpenTakaModal();
            }
         }
      },
      [itemData, onOpenModal, daybook, businessTypes?.businessType, row.lineItem, onOpenTakaDetailModal, onOpenTakaModal],
   );

   const handleTakaDetails = useCallback(
      (takaDetails) => {
         takaDetails = takaDetails
            ?.filter((q) => q.qty > 0)
            ?.map((t) => ({
               ...(t.id && id && { id: t.id }),
               quantity1: 0,
               quantity2: 0,
               quantity3: t.qty ? Number(t.qty) : 0,
               notes1: '',
               // issueLineDetailId: null,
               RQuantity1: 0,
               RQuantity2: 0,
               RQuantity3: 0,
            }));
         const totalTaka = takaDetails?.reduce((acc, item) => acc + Number(item?.quantity3 || 0), 0);
         setRow((prev) => ({
            ...prev,
            lineItem: prev?.lineItem?.map((item, idx) => {
               if (currentIndex === idx) {
                  const selectedItem = itemData.find((i) => i.id === item.itemId);
                  const unit = item.unit ?? selectedItem.ratepersalesid;
                  const qty1 = takaDetails?.length > 0 ? takaDetails?.length : 0;
                  const qty2 = selectedItem?.defaultcut > 0 ? Number(selectedItem?.defaultcut) : 0;
                  const qty3 = totalTaka;
                  handleQtyChange('qty1', qty1, idx);
                  handleQtyChange('qty2', qty2, idx);
                  handleQtyChange('qty3', qty3, idx);
                  return {
                     ...item,
                     qty1: qty1,
                     qty2: qty2,
                     qty3: qty3,
                     unit: unit,
                     takaDetails: [...takaDetails, { itemId: item.itemId }],
                  };
               }
               return item;
            }),
         }));
      },
      [currentIndex, handleQtyChange, itemData?.length],
   );

   const handleSaveTakaDetail = useCallback(
      (data) => {
         if (currentIndex === null || currentIndex === undefined) return;
         let newRows = { ...row };
         const selectedTakaDetail = data.filter((a) => a.mts > 0);
         const totalTakaDetails = selectedTakaDetail.reduce((acc, item) => acc + Number(item?.mts || 0), 0);
         newRows.lineItem[currentIndex].qty1 = selectedTakaDetail?.length;
         newRows.lineItem[currentIndex].qty2 = 0;
         newRows.lineItem[currentIndex].qty3 = totalTakaDetails;
         newRows.lineItem[currentIndex].takaDetails = data;
         setRow(newRows);
      },
      [currentIndex],
   );

   const handleItemPrice = useCallback(
      async (itemId, type) => {
         if (daybook?.partyItemWiseLastRate || daybook?.itemWiseLastRate) {
            const params = { itemId, companyId: company?.id, type };
            if (daybook?.partyItemWiseLastRate) {
               params.accountId = account?.id;
            }
            const res = await dispatch(getItemPrice(params));
            return res?.data?.itemPrice ?? '';
         }
      },
      [account?.id, company?.id, daybook?.itemWiseLastRate, daybook?.partyItemWiseLastRate, dispatch],
   );

   const handleOnChange = async (header, name, value, idx) => {
      const newRow = { ...row };
      const lineItem = newRow.lineItem[idx];

      if (['qty1', 'qty2', 'qty3'].includes(name)) {
         handleQtyChange(name, value, idx);
      }
      if (name === 'itemRate') {
         const gstRate = getGstRate(value, newRow, header, idx);
         newRow[header][idx].gstWithRate = gstRate;
         handleRateChange(name, value, idx);
      }
      if (name === 'gstWithRate') {
         const gstRate = Number(value || 0);
         const gstPercent = Number(newRow[header][idx].gst || 0);
         const itemRate = gstRate / (1 + gstPercent / 100);
         handleRateChange('itemRate', Number(itemRate || 0)?.toFixed(2), idx);
      }
      if (name === 'amount') {
         const selectedItem = itemData.find((i) => i.id === newRow[header][idx].itemId);
         const unit = newRow[header][idx].unit;
         const qty =
            unit === selectedItem?.uqc1Data?.id
               ? newRow[header][idx].qty1
               : unit === selectedItem?.uqc2Data?.id
                  ? newRow[header][idx].qty2
                  : unit === selectedItem?.uqc3Data?.id
                     ? newRow[header][idx].qty3
                     : newRow[header][idx].qty1;
         const itemRate = Number(value || 0) / qty;
         const gstPercent = Number(newRow[header][idx].gst || 0);
         const gstRate = itemRate * (1 + gstPercent / 100);
         newRow[header][idx].gstWithRate = gstRate;
         handleRateChange('itemRate', itemRate, idx);
      }
      if (name === 'taxableAmount') {
         const selectedItem = itemData.find((i) => i.id === newRow[header][idx].itemId);
         const unit = newRow[header][idx].unit;
         const qty =
            unit === selectedItem?.uqc1Data?.id
               ? newRow[header][idx].qty1
               : unit === selectedItem?.uqc2Data?.id
                  ? newRow[header][idx].qty2
                  : unit === selectedItem?.uqc3Data?.id
                     ? newRow[header][idx].qty3
                     : newRow[header][idx].qty1;
         const itemRate = Number(value || 0) / qty;
         const gstPercent = Number(newRow[header][idx].gst || 0);
         const gstRate = itemRate * (1 + gstPercent / 100);
         newRow[header][idx].gstWithRate = gstRate;
         handleRateChange('itemRate', itemRate, idx);
      }
      if (['addLess1Percent', 'addLess2Percent', 'addLess3Percent'].includes(name)) {
         handleDiscountChange(name, value, idx);
      }

      if (name === 'unit') {
         handleUnitChange(value, idx);
      }

      const daybook = filteredDaybooks.find((item) => item.id === row?.header?.daybookId);
      if (name === 'itemId') {
         const selectedItem = itemData.find((x) => x.id === Number(value));

         newRow[header][idx].unit = selectedItem?.ratepersalesid;
         setCurrentLineItemIdx(idx);
         handleQtyChange('qty1', 0, idx);
         handleQtyChange('qty2', 0, idx);
         handleQtyChange('qty3', 0, idx);
         handleRateChange('itemRate', 0, idx);
         handleDiscountChange('addLess1Percent', 0, idx);
         handleDiscountChange('addLess2Percent', 0, idx);
         handleDiscountChange('addLess3Percent', 0, idx);
         handleItemChange(name, value, idx, "saleschallan");
         if (selectedItem?.salesprice1) {
            const gstRate = getGstRate(selectedItem?.salesprice1, newRow, header, idx);
            newRow[header][idx].gstWithRate = gstRate;
         }
         const itemPrice = await handleItemPrice(value, 'sales');
         const rate = getGstRate(itemPrice, newRow, header, idx);
         newRow[header][idx].gstWithRate = rate;
         handleRateChange('itemRate', itemPrice, idx);
         if (businessTypes?.businessType?.toUpperCase() === 'MOBILE') {
            await dispatch(
               getStock({
                  itemId: Number(value),
                  companyId: user?.loginhistory?.companyId,
                  daybookId: daybook?.purchaseDaybookId,
                  isReceiveStock: false,
               }),
            );
         }

         newRow.lineItem[idx].stock = [];
         handleStockModal(value, idx);
      }

      let subHsn;
      if (company?.setting?.applyGST && daybook?.applyGst && newRow[header][idx].itemId) {
         if (name === 'typeOfSupply') {
            if (value === 1) {
               if (lineItem?.hsnData?.subHsn?.length === 1) {
                  subHsn = lineItem?.hsnData?.subHsn[0];
               } else {
                  subHsn = lineItem?.hsnData?.subHsn?.find(
                     (hsn) => lineItem.itemRate >= hsn.fromRate && lineItem.itemRate <= hsn.toRate,
                  );
               }
            }
            if (value === 2) {
               if (lineItem?.sacData?.subHsn?.length === 1) {
                  subHsn = lineItem?.sacData?.subHsn[0];
               } else {
                  subHsn = lineItem?.sacData?.subHsn?.find(
                     (hsn) => lineItem.itemRate >= hsn.fromRate && lineItem.itemRate <= hsn.toRate,
                  );
               }
            }
            const taxRate = parseFloat(subHsn?.gst) / 100;
            newRow[header][idx].gst = subHsn?.gst ?? 0;
            newRow[header][idx].subHSNId = subHsn?.id ?? 0;
            newRow[header][idx].gstAmount = lineItem.itemRate * lineItem.qty1 * taxRate;
            newRow[header][idx].ratio = subHsn?.ratio ?? null;
         }
      }
      newRow[header][idx][name] = value;
      setRow(newRow);
      setErrors((prev) => {
         const obj = prev;
         const fullName = `${header}[${idx}].${name}`;
         delete obj[fullName];
         return obj;
      });
   };

   const handleBillTermChange = useCallback(
      (index, values) => {
         setBillTerms((prev) => {
            const newBillTerms = [...prev];
            newBillTerms[index] = {
               ...newBillTerms[index],
               ...values,
            };
            // Get the current basic amount
            const currentBasicAmount = parseFloat(row.header.basicAmount) || 0;

            // Calculate addition and deduction totals based on the basic amount
            let additionTotal = 0;
            let deductionTotal = 0;

            newBillTerms.forEach((term, idx) => {
               const amount = parseFloat(term.amount) || 0;
               const termData = billTermData[idx];

               if (termData?.signname === 'Subtraction') {
                  deductionTotal += Math.abs(amount);
               } else if (termData?.signname === 'Addition') {
                  additionTotal += Math.abs(amount);
               } else if (termData?.signname === 'Both') {
                  if (amount < 0) {
                     deductionTotal += Math.abs(amount);
                  } else {
                     additionTotal += amount;
                  }
               }
            });

            // Calculate net amount based on the basic amount
            const netAmount = currentBasicAmount + additionTotal - deductionTotal;

            let billTerm = additionTotal - deductionTotal;
            let netTotal = totals.netAmount + additionTotal;
            netTotal = netTotal - deductionTotal;
            setBillTerm(billTerm);
            setTotalBillTermAmount(netTotal);

            // Update the header amounts
            setRow((prev) => ({
               ...prev,
               header: {
                  ...prev.header,
                  additionAmount: additionTotal.toFixed(2),
                  deductionAmount: deductionTotal.toFixed(2),
                  netAmount: netAmount.toFixed(2),
                  basicAmount: currentBasicAmount.toFixed(2),
               },
            }));

            return newBillTerms;
         });
      },
      [billTermData, row.header.basicAmount, setBillTerm, setTotalBillTermAmount, totals.netAmount],
   );

   const addLineItem = () => {
      setRow((prev) => ({
         ...prev,
         lineItem: [...prev.lineItem, { ...initialLineItem }],
      }));
   };

   const removeLineItem = (index, id) => {
      if (id) {
         Swal.fire({
            title: 'Are you sure?',
            text: `This entry is marked for removal/emptying. Please ensure this entry is saved permanently before proceeding.`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!',
         }).then((result) => {
            if (result.isConfirmed) {
               setRow((prev) => ({
                  ...prev,
                  lineItem: prev.lineItem
                     .map((li, idx) => {
                        if (!li.itemId) return null;
                        return li.id === id ? { ...li, isDeleted: true } : li;
                     })
                     .filter(Boolean),
               }));
            }
         });
      } else {
         setRow((prev) => ({
            ...prev,
            lineItem: prev.lineItem.filter((_, i) => i !== index),
         }));
      }
   };

   const handleDelete = () => {
      if (deleteLineItemId) dispatch(deleteSalesLineItem(deleteLineItemId));
      if (row.lineItem?.length >= 0) {
         setRow((prev) => ({
            ...prev,
            lineItem: prev.lineItem.filter((_, i) => i !== currentLineItemIdx),
         }));
      }
      setDeleteLineItemId(null);
      onCloseDeleteModal();
      setCurrentLineItemIdx(null);
   };

   const removeStock = useCallback(
      (stock) => {
         const updatedLineItem = row.lineItem.map((lineItem, idx) => {
            const selectedItem = itemData.find((i) => i.id === lineItem.itemId);
            const stockData = lineItem.stock.filter((s) => s.serialNo !== stock.serialNo);
            const qty1 = stockData?.length;

            if (selectedItem && selectedItem?.itemdetailtype === 1 && qty1 === 0) {
               handleQtyChange('qty1', qty1, idx);
               itemRefs.current[idx].focus();
               return { ...lineItem, itemId: '', stock: [], qty1: qty1, itemRate: 0 };
            }
            if (selectedItem && selectedItem?.itemdetailtype === 1 && qty1 > 0) {
               handleQtyChange('qty1', qty1, idx);
               return { ...lineItem, stock: stockData, qty1: qty1 };
            }

            return lineItem;
         });

         setRow((prev) => ({
            ...prev,
            lineItem: updatedLineItem,
         }));
      },
      [handleQtyChange, itemData, row.lineItem],
   );

   const handleEditValues = useCallback(async () => {
      if (id && salesInvoice) {
         setRow({
            header: {
               daybookId: salesInvoice.daybookId,
               docno: salesInvoice.docno,
               transactionAt: salesInvoice.transactionAt
                  ? moment(salesInvoice.transactionAt, 'DD/MM/YYYY').format('YYYY-MM-DD')
                  : '',
               dueAt: salesInvoice.dueAt ? new Date(salesInvoice.dueAt).toISOString().split('T')[0] : '',
               dueDays: salesInvoice.dueDays,
               accountId: salesInvoice.accountId,
               basicAmount: salesInvoice.basicAmount,
               netAmount: salesInvoice.netAmount,
               notes: salesInvoice.notes,
               transportId: salesInvoice.transportId,
               vehicleId: salesInvoice.vehicleId,
               representativeId: salesInvoice.representativeId,
               brokerId: salesInvoice.brokerId,
               warehouseId: salesInvoice.warehouseId,
               incomeId: salesInvoice.incomeId,
            },
            lineItem: salesInvoice.lineitems?.map((item, index) => {
               if (item?.minQty1 > 0 || item?.minQty2 > 0 || item?.minQty3 > 0) {
                  setFiledDisabled(true);
               }
               return {
                  ...item,
                  itemRate: item.itemRate?.toString(),
                  amount: item.amount,
                  typeOfSupply: Number(item.typeOfSupply),
                  netAmount: item.netAmount,
                  taxableAmount: item.taxableAmount,
                  ratio: item.ratio,
                  addLess1Percent: item.addLess1Percent,
                  addLess1Amount: item.addLess1Amount,
                  addLess2Percent: item.addLess2Percent,
                  addLess2Amount: item.addLess2Amount,
                  addLess3Percent: item.addLess3Percent,
                  addLess3Amount: item.addLess3Amount,
                  gst: item.gstPercent,
                  unit: item.ratePer,
                  isDeleted: false,
                  notes: item.notes ? item.notes : '',
                  remarks: item.remarks ? item.remarks : '',
                  gstWithRate: item.gstWithRate ? item.gstWithRate : null,
                  isDisabled: (item?.minQty1 > 0 || item?.minQty2 > 0 || item?.minQty3 > 0) ? true : false,
                  stock: Array.isArray(item.lineDetails) && item.lineDetails?.length > 0 && businessTypes?.businessType?.toUpperCase() === 'MOBILE' ? item.lineDetails?.map((stock) => {
                     return {
                        ...stock,
                        pcs: stock.quantity1,
                     };
                  }) : [],
                  takaDetails: Array.isArray(item.lineDetails) && item.lineDetails?.length > 0 && businessTypes?.businessType?.toUpperCase() === 'TEXTILE' ? item.lineDetails?.map((x) => ({
                     ...x,
                     quantity3: x.quantity3,
                     mts: x.mts || x.quantity3,
                     usedMeter: x.maxQty3,
                  })) : [],
               };
            }),
         });

         const initialBillTerms = billTermData?.map((term) => {
            const billTerm = salesInvoice.salebillterms?.find((billTerm) => billTerm.billTermId === term.id);
            if (billTerm) {
               return {
                  id: billTerm?.id,
                  billTermId: term.id,
                  percentage: billTerm?.percentage || 0,
                  amount: billTerm?.amount || 0,
               };
            } else {
               return {
                  billTermId: term.id,
                  percentage: 0,
                  amount: 0,
               };
            }
         });
         setBillTerms(initialBillTerms);
      }
   }, [dispatch, id, salesInvoice, billTermData?.length, setFiledDisabled]);
   // billTermData, dispatch, hasFetchedAccount, id, salesInvoice

   const handleInputChange = useCallback((header, e, idx) => {
      const { name, value } = e.target;

      setRow((prev) => ({
         ...prev,
         [header]: {
            ...prev[header],
            [name]: value,
         },
      }));

      if (name === 'dueDays') {
         setRow((prev) => ({
            ...prev,
            [header]: {
               ...prev[header],
               dueAt: moment().add(Number(value), 'days').format('YYYY-MM-DD'),
            },
         }));
      }

      setErrors((prev) => {
         const obj = prev;
         const fullName = `${header}.${name}`;
         delete obj[fullName];
         return obj;
      });
   }, []);

   const dataSave = _.debounce(
      async () => {
         const isValid = await validateForm();

         if (isValid) {
            setIsLoading(true);
            const exchangesData = exchange?.length > 0 ? exchange : exchangeData.current.exchanges;
            const exchangePaymentData =
               exchangePayments?.length > 0 ? exchangePayments : exchangeData.current.exchangePayments;

            const payload = {
               header: {
                  ...row.header,
                  ...(id && { id: id }),
                  daybookId: Number(row.header.daybookId),
                  docno: row.header?.docno?.toString()?.trim(),
                  transactionAt: moment(row.header.transactionAt).format('YYYY-MM-DD'),
                  companyId: Number(user?.loginhistory?.companyId),
                  accountId: Number(row.header.accountId),
                  brokerId: row.header.brokerId || null,
                  basicAmount: formatAmount(Number(totals.netAmount)),
                  additionAmount: row.header.additionAmount ? Number(row.header.additionAmount) : 0,
                  deductionAmount: row.header.deductionAmount ? Number(row.header.deductionAmount) : 0,
                  netAmount: formatAmount(Math.round(Number(finalNetAmount))),
                  dueDays: row.header.dueDays ? Number(row.header.dueDays) : 0,
                  dueAt: moment(row.header.dueAt).format('YYYY-MM-DD'),
                  billtoStateId: getAccountAddress(accountData, row.header.accountId)?.billingAddress?.stateId ?? null,
                  shiptoStateId: getAccountAddress(accountData, row.header.accountId)?.shippingAddress?.stateId ?? null,
                  warehouseId:
                     companyData?.setting?.warehouseWishStock === true && herderview === true
                        ? row.header.warehouseId === null
                           ? selectdaybookdata?.wareHouseId ?? companyData?.setting?.warehouseId ?? 1
                           : row.header.warehouseId
                        : null,
                  notes: row.header.notes || null,
                  vehicleId: row.header.vehicleId || null,
                  transportId: row.header.transportId || null,
                  representativeId: row.header.representativeId || null,
                  gstAmount: totals.netGstAmount ? totals.netGstAmount : 0,
                  taxableAmount: totals.taxableAmount ? totals.taxableAmount : 0,
                  gstTxnType: getGstTaxType(company, account, 'sales'),
                  gstSubTxnType: getGstSubTaxType(company, account, 'sales'),
                  assesseType: companyList?.assesseType ? companyList?.assesseType : 0,
                  distance: companyList?.distanceKM ? companyList?.distanceKM : 0,
                  incomeId: row.header.incomeId || null,
                  // voucherId: voucher,
               },
               lineItems: row.lineItem?.map((item) => {
                  const selectedItem = itemData?.find((i) => i.id.toString() === item.itemId?.toString());

                  const finalWarehouse =
                     companyData?.setting?.warehouseWishStock === true && herderview === true
                        ? row.header.warehouseId === null
                           ? selectdaybookdata?.wareHouseId ?? companyData?.setting?.warehouseId ?? 1
                           : row.header.warehouseId
                        : companyData?.setting?.warehouseWishStock === true && lineitemview === true
                           ? item.warehouseId === null
                              ? selectdaybookdata?.wareHouseId ?? companyData?.setting?.warehouseId ?? 1
                              : item.warehouseId
                           : null;

                  const finalStockWarehouse =
                     companyData?.setting?.warehouseWishStock === true && herderview === true
                        ? row.header.warehouseId === null
                           ? selectdaybookdata?.wareHouseId ?? companyData?.setting?.warehouseId ?? 1
                           : row.header.warehouseId
                        : companyData?.setting?.warehouseWishStock === true && lineitemview === true
                           ? item.warehouseId === null
                              ? selectdaybookdata?.wareHouseId ?? companyData?.setting?.warehouseId ?? 1
                              : item.warehouseId
                           : companyData?.setting?.warehouseWishStock === true && lineDetailview === true
                              ? item.warehouseId === null
                                 ? selectdaybookdata?.wareHouseId ?? companyData?.setting?.warehouseId ?? 1
                                 : item.warehouseId
                              : null;

                  return {
                     ...(item.id && { id: item.id }),
                     typeOfSupply: item.typeOfSupply ? item.typeOfSupply : 1,
                     itemId: item.itemId ? Number(item.itemId) : 0,
                     lineNumber: item.lineNumber ? Number(item.lineNumber) : 1,
                     itemRate: item.itemRate ? Number(item.itemRate) : 0,
                     amount: item.amount ? Number(item.amount) : 0,
                     netAmount: item.netAmount ? formatAmount(Number(item.netAmount)) : 0,
                     ratePer: item.unit && item.unit > 0 ? item.unit : selectedItem?.ratepersalesid,
                     uomNoForRate:
                        item.unit > 0 && item.unit === selectedItem.uqcid1
                           ? 1
                           : item.unit > 0 && item.unit === selectedItem.uqcid2
                              ? 2
                              : item.unit > 0 && item.unit === selectedItem.uqcid3
                                 ? 3
                                 : 1,
                     qUnitId1: selectedItem?.uqcid1,
                     qUnitId2: selectedItem?.uqcid2,
                     qUnitId3: selectedItem?.uqcid3,
                     qty1: item.qty1 ? Number(item.qty1) : 0,
                     qty2: item.qty2 ? Number(item.qty2) : 0,
                     qty3: item.qty3 ? Number(item.qty3) : 0,
                     addLess1Percent: item.addLess1Percent ? Number(item.addLess1Percent) : 0,
                     addLess1Amount: item.addLess1Amount ? item.addLess1Amount : 0,
                     addLess2Percent: item.addLess2Percent ? Number(item.addLess2Percent) : 0,
                     addLess2Amount: item.addLess2Amount ? item.addLess2Amount : 0,
                     addLess3Percent: item.addLess3Percent ? Number(item.addLess3Percent) : 0,
                     addLess3Amount: item.addLess3Amount ? item.addLess3Amount : 0,
                     taxableAmount: item.taxableAmount ? item.taxableAmount : 0,
                     netGst: item.netGst ? item.netGst : 0,
                     gstPercent: item.gst ? item.gst : 0,
                     cgst: isSameState ? totals.netGstAmount / 2 : 0,
                     sgst: isSameState ? totals.netGstAmount / 2 : 0,
                     igst: isSameState ? 0 : totals.netGstAmount,
                     stock:
                        Array.isArray(item.stock) && item.stock?.length > 0 && businessTypes?.businessType?.toUpperCase() === 'MOBILE'
                           ? item.stock.map((s) => ({
                              ...s,
                              itemId: item.itemId,
                              warehouseId: s.warehouseId ? s.warehouseId : finalStockWarehouse,
                              returnStatus: undefined,
                              warehouseName: undefined,
                           }))
                           : [],
                     hsnId: selectedItem?.hsnid,
                     sacId: selectedItem?.sacid,
                     soliId: item?.soliId,
                     warehouseId: finalWarehouse,
                     isDeleted: item.isDeleted ? item.isDeleted : false,
                     notes: item.notes ? item.notes : null,
                     remarks: item.remarks ? item.remarks : null,
                     takaDetails: Array.isArray(item.takaDetails) && item?.takaDetails?.length > 0 && businessTypes?.businessType?.toUpperCase() === 'TEXTILE'
                        ? item.takaDetails
                           .filter((x) => x?.mts > 0 || x?.quantity3 > 0)
                           .map((a) => ({
                              ...(a.id && id && { id: a.id }),
                              // issueLineDetailId: a.issueLineDetailId,
                              notes1: a.remarks ? (a.remarks ?? '') : (a.notes1 ?? ''),
                              notes2: "",
                              notes3: "",
                              RQuantity1: a.RQuantity1 ? a.RQuantity1 : 0,
                              RQuantity2: a.RQuantity2 ? a.RQuantity2 : 0,
                              RQuantity3: a.usedMeter && a.usedMeter > 0 ? a.usedMeter : a.RQuantity3,
                              quantity1: a.quantity1 ? a.quantity1 : 0,
                              quantity2: a.quantity2 ? a.quantity2 : 0,
                              quantity3: a.mts && a.mts > 0 ? a.mts : a.quantity3,
                           }))
                        : [],
                  };
               }),
               billTerms: billTerms?.map((term) => ({
                  ...(term.id && { id: term.id }),
                  billTermId: Number(term.billTermId),
                  percentage: Number(term.percentage),
                  amount: Number(term.amount),
               })),
            };

            let res;
            if (id) {
               res = await dispatch(updateSaleChallan(payload));
            } else {
               res = await dispatch(addSaleChallan(payload));
            }

            if (res?.code === 2) {
               setIsLoading(false);
               return;
            }

            if (res?.code === 1 && invoiceImages?.length > 0) {
               const formData = new FormData();
               formData.append('id', res?.data?.id);
               invoiceImages.forEach((imgObj) => {
                  if (!imgObj.isExisting && imgObj.file) {
                     formData.append('bill', imgObj.file);
                  }
               });

               const response = await dispatch(uploadSalesDocument(formData));

               if (response?.code === 1) {
                  setInvoiceImages([]);
               }
            }

            const salesId = res?.data?.header?.id;
            const data = {
               id: salesId,
               type: 'sales',
            };

            let eInvoiceRes;
            let eWayBillRes;
            if (
               daybook?.ewayInvoice &&
               company?.setting?.ewayInvoice &&
               company?.setting?.eInvoiceUserName &&
               company?.setting?.eInvoicePassword &&
               isEInvoice
            ) {
               eInvoiceRes = await dispatch(generateEInvoice(data));
            }
            if (
               daybook?.ewayBill &&
               company?.setting?.ewayBill &&
               company?.setting?.eWayUserName &&
               company?.setting?.eWayPassword &&
               isEWayBill
            ) {
               eWayBillRes = await dispatch(generateEWayBill(data));
            }
            if (eInvoiceRes?.code === 2 || eWayBillRes?.code === 2) {
               setIsLoading(false);
               navigate(`/admin/sales/challan/edit/${salesId}`);
               return;
            }
            if (res?.code === 1) {
               if (user?.loginhistory?.companyId) {
                  dispatch(
                     getDaybook({
                        companyId: Number(user?.loginhistory?.companyId),
                        ...(shouldSendCompanyIdDaybook && { companyIds: user?.loginhistory?.companyId }),
                     }),
                  );
                  dispatch(
                     getItem({
                        companyId: user?.loginhistory.companyId,
                        sortBy: 'name',
                        sortOrder: 'asc',
                        ...(shouldSendCompanyIdItem && { companyIds: user?.loginhistory?.companyId }),
                     }),
                  );
                  dispatch(
                     getAccount({
                        compId: Number(user?.loginhistory?.companyId),
                        accountTypes: ['K', 'E', 'C', 'D', 'BROKER', 'I', 'L', 'M', 'N', 'A'].join(','),
                        status: true,
                        ...(shouldSendCompanyIdAccount && { companyIds: user?.loginhistory?.companyId }),
                     }),
                  );
               }
               // ✅ CAPTURE THE COMPLETE SAVED DATA
               setSalesData(res.data);
               setSavedSalesId(salesId);

               if (daybook?.onlinePrinting) {
                  if (daybook?.askBeforePrint) {
                     // ✅ OPEN MODAL FIRST - BEFORE SHOWING CONFIRMATION
                     // setShouldOpenModalForWpSettings(true);

                     Swal.fire({
                        title: 'Do you want to Print Document?',
                        showCancelButton: true,
                        confirmButtonText: 'Yes',
                        cancelButtonText: 'No',
                        cancelButtonColor: '#d33',
                        confirmButtonColor: '#3085d6',
                     }).then(async (result) => {
                        if (result.isConfirmed) {
                           setShouldOpenModalForWpSettings(true);
                           if (daybook?.printingSettings === 0) {
                              setIsLoading(false);
                              handleFormClose();
                              const resp = await dispatch(
                                 getSetupFormat({
                                    companyId: user?.loginhistory?.companyId,
                                    daybookId: row.header.daybookId,
                                    functionName: 'Sales Invoice',
                                 }),
                              );
                              if (resp?.code === 1) {
                                 setShouldOpenModalForWpSettings(false);
                              }
                              const defaultFormat = prints.find((a) => a.isDefault);
                              if (defaultFormat) {
                                 const result = await dispatch(
                                    setupFormatCustomQuery({
                                       query: defaultFormat?.PrintFormat?.query,
                                    }),
                                 );
                                 if (result && result?.data && result?.data?.length > 0) {
                                    const html = injectDataIntoHtml(
                                       defaultFormat?.PrintFormat?.html,
                                       result?.data?.length > 0 ? result?.data : [],
                                    );
                                    // dispatch(emptySales());
                                    // handleReset();
                                    handlePrintClick(
                                       {},
                                       html,
                                       defaultFormat?.PrintFormat?.css,
                                       navigate,
                                       '/admin/sales/challan',
                                    );
                                 }
                              }
                           } else {
                              // dispatch(emptySales());
                              // handleReset();
                              setShouldOpenModalForWpSettings(true);
                              onOpenPrintFormatModal();
                           }
                           handleFormClose();
                           // navigate('/admin/sales/invoice');
                        }

                        if (result.isDismissed) {
                           if (daybook.sendWhatsApp && daybook.wpSettings === 1) {
                              const resp = await dispatch(
                                 getSetupFormat({
                                    companyId: user?.loginhistory?.companyId,
                                    daybookId: row.header.daybookId,
                                    functionName: 'Sales Invoice',
                                 }),
                              );
                              setShouldOpenModalForWpSettings(true);
                           } else {
                              handleFormClose();
                              handleReset();
                              navigate('/admin/sales/challan');
                           }
                           // navigate('/admin/sales/invoice');
                           setIsLoading(false);
                           // ✅ Always run AFTER Swal closes (Yes or No)
                           // handleFormClose();
                           // navigate('/admin/sales/invoice');
                        }
                     });

                     return;
                  }
               }

               // ✅ SHOW SALES DETAILS AND CLOSE FORM
               setShowSalesDetails(true);
               handleFormClose();
               handleReset();
               navigate('/admin/sales/challan');
            }
            setIsLoading(false);
            return;
         } else {
            toast({
               title: 'Validation Error',
               description: getFirstErrorMessage(errors),
               status: 'error',
               duration: 3000,
               isClosable: true,
            });
         }
      },
      500,
      { leading: true, trailing: false },
   );

   const handleSubmit = useCallback(async () => {
      setIsLoading(true);
      const now = Date.now();
      if (now - lastClick.current < 1000) {
         return;
      }
      lastClick.current = now;
      const financialYear = financialYears.find((a) => a.financial_year === user?.financialYear);

      const data = {
         daybookId: row.header.daybookId,
         docno: row.header.docno?.toString()?.trim(),
         companyId: user?.loginhistory?.companyId,
         fromDate: moment(financialYear?.fy_start_date, 'DD/MM/YYYY').format('YYYY-MM-DD'),
         toDate: moment(financialYear?.fy_end_date, 'DD/MM/YYYY').format('YYYY-MM-DD'),
      };
      if (id) data.id = Number(id);
      const res = await dispatch(checkDocNo(data));
      if (res && res.code === 1 && res.data?.isError) {
         Swal.fire({
            title: res?.data?.message,
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            cancelButtonColor: '#d33',
            confirmButtonColor: '#3085d6',
         }).then(async (result) => {
            if (result.isConfirmed) {
               const newRow = { ...row };
               newRow.header.docno = res.data?.newDocNo.toString();
               setRow(newRow);
               await dataSave();
            }

            if (result.isDismissed) {
               setIsLoading(false);
               return;
            }
         });
      } else if (res && res.code === 1 && !res.data?.isError) {
         await dataSave();
      } else {
         setIsLoading(false);
      }
   }, [dataSave, dispatch, id, row, user?.loginhistory?.companyId]);

   const handleFormClose = () => {
      // Refresh the list
      dispatch(
         getSaleChallan({
            page: 1,
            limit: 10,
            companyId: user?.loginhistory?.companyId,
            sortBy: 'id',
            sortOrder: 'desc',
         }),
      );

      // Clear form states but keep important data
      setVoucher(null);
      dispatch(emptySales());

      // Clear localStorage
      localStorage.removeItem('daybook');
      localStorage.removeItem('accountId');

      // Navigate back to list
      // navigate('/admin/sales/invoice');
   };

   const handleSelectStock = useCallback(
      (e, stock) => {
         if (e.target.checked) {
            const newStock = {
               itemId: stock.itemId,
               itemName: stock.itemName,
               pcs: stock.pcs,
               serialNo: stock.serialNo,
               serialNo2: stock.serialNo2,
               barcode: stock.barcode,
               warehouseName: stock.warehouseName,
               warehouseId: stock.warehouseId,
               isOld: stock.isOld,
               pinvLineDetailId: stock.daybooktype === 11 ? stock.id : null,
               salesReturnLineDetailId: stock.daybooktype === 6 ? stock.id : null,
            };

            setRow((prevRow) => ({
               ...prevRow,
               lineItem: prevRow.lineItem?.map((item, idx) => {
                  if (currentLineItemIdx === idx) {
                     const isExists = item.stock.some((item) => item.serialNo === stock.serialNo);
                     const stockData = isExists ? item.stock : [...item.stock, newStock];
                     handleQtyChange('qty1', stockData?.length, idx);
                     return { ...item, stock: stockData, qty1: stockData?.length };
                  }
                  return item;
               }),
            }));
         } else {
            setRow((prevRow) => ({
               ...prevRow,
               lineItem: prevRow.lineItem?.map((item, idx) => {
                  if (currentLineItemIdx === idx) {
                     const stockData = item.stock.filter((a) => a.serialNo.toString() !== stock.serialNo.toString());
                     handleQtyChange('qty1', stockData?.length, idx);
                     return { ...item, stock: stockData, qty1: stockData?.length };
                  }
                  return item;
               }),
            }));
         }
      },
      [currentLineItemIdx],
   );

   const handlePaymentOnChange = useCallback(
      (e, index) => {
         const { name, value } = e.target;
         const newPaymentData = [...paymentData];
         newPaymentData[index][name] = value;
         setPaymentData(newPaymentData);
      },
      [paymentData],
   );

   const handlePayment = useCallback(() => {
      if (daybookPaymentData?.length > 0) {
         const payment = daybookPaymentData?.map((payment) => {
            return { daybookName: payment.name, daybookId: payment.id, account: 0 };
         });
         setPaymentData(payment);
      }
   }, [daybookPaymentData]);

   const handleAskToVerifyCustomer = useCallback(
      async (fields, paymentData) => {
         const isValid = await validateForm();
         setExchange(fields);
         setExchangePayments(paymentData);
         if (isValid) {
            if (fields?.length > 0 && (exchangeDaybook?.isAskToAllow || selectedDaybook?.isAskToAllow)) {
               onOpenVerifyModal();
               return true;
            } else {
               setExchange(fields);
               setExchangePayments(paymentData);
               exchangeData.current = { exchanges: fields, exchangePayments: paymentData };
               handleSubmit();
               // return false;
            }
         } else {
            toast({
               title: 'Validation Error',
               description: getFirstErrorMessage(errors),
               status: 'error',
               duration: 3000,
               isClosable: true,
            });
            return false;
         }
      },
      [
         errors,
         exchangeDaybook?.isAskToAllow,
         handleSubmit,
         onOpenVerifyModal,
         selectedDaybook?.isAskToAllow,
         toast,
         validateForm,
      ],
   );

   const handleAskToVerifyCustomerForSales = useCallback(async () => {
      const isValid = await validateForm();

      if (isValid) {
         if (selectedDaybook && selectedDaybook?.isAskToAllow) {
            onOpenVerifyModal();
         } else {
            try {
               const submittedData = await handleSubmit();
               if (submittedData) {
                  setSalesData(submittedData);
               }
            } catch (error) {
               // Handle cancellation gracefully - don't show error for user cancellation
               if (error.message === 'User cancelled document number change') {
                  console.log('Save operation cancelled by user');
               } else {
                  console.error('Submission failed:', error);
               }
            }
         }
      } else {
         toast({
            title: 'Validation Error',
            description: getFirstErrorMessage(errors),
            status: 'error',
            duration: 3000,
            isClosable: true,
         });
      }
   }, [errors, handleSubmit, onOpenVerifyModal, selectedDaybook, toast, validateForm]);

   const handleReset = useCallback(async () => {
      const initialRow = {
         header: {
            daybookId: lastSaleDaybook?.daybookId || '',
            docno: '',
            transactionAt: new Date().toISOString().split('T')[0],
            companyId: '',
            accountId: '',
            brokerId: '',
            basicAmount: 0,
            additionAmount: '',
            deductionAmount: '',
            netAmount: 0,
            dueDays: 0,
            dueAt: new Date().toISOString().split('T')[0],
            billtoStateId: null,
            shiptoStateId: null,
            warehouseId: null,
            notes: '',
            vehicleId: null,
            transportId: null,
            representativeId: user?.id,
         },
         lineItem: [initialLineItem],
      };
      setRow(initialRow);
      if (user && user?.loginhistory?.companyId) {
         await dispatch(
            getPaymentDaybook({
               isPayment: true,
               companyId: user?.loginhistory?.companyId,
               ...(shouldSendCompanyIdDaybook && { companyIds: user?.loginhistory?.companyId }),
            }),
         );
      }
      handlePayment();
      setBillTerms([]);
      await dispatch(emptySales());
      localStorage.removeItem('daybook');
      localStorage.removeItem('accountId');
   }, [dispatch, handlePayment, initialLineItem, lastSaleDaybook?.daybookId, shouldSendCompanyIdDaybook, user]);

   const getSalesInvoiceData = useCallback(async () => {
      if (id) dispatch(getSaleChallanById(id));
   }, [dispatch, id]);

   const getData = useCallback(async () => {
      setIsPageLoading(true);
      if (user && user?.loginhistory?.companyId) {
         await dispatch(
            getWarehouse({ ...(shouldSendCompanyIdWarehouse && { companyIds: user?.loginhistory?.companyId }) }),
         );
         await dispatch(
            getTransport({ ...(shouldSendCompanyIdTransport && { companyIds: user?.loginhistory?.companyId }) }),
         );
         await dispatch(
            getVehicle({ ...(shouldSendCompanyIdVehicle && { companyIds: user?.loginhistory?.companyId }) }),
         );
         dispatch(getFinancialYears({ companyId: user?.loginhistory?.companyId }));
      }
      await dispatch(getMainAndSubHsn());
      await dispatch(getGLGroupsAllDropdown());
      await dispatch(getUsers());
      setIsPageLoading(false);
   }, [dispatch, user, user?.loginhistory?.companyId]);

   const handleSerialHistory = (item) => {
      setSelectedItem(item);
      dispatch(getSerialWiseHistory({ companyIds: user?.loginhistory?.companyId, serialNo: item.serialNo }));
   };

   const handleAdjustedDocs = () => {
      setShouldFetch(true); // Triggers useEffect
      const selectedDaybookData = daybookData.filter((item) => item.id === row.header.daybookId);
      setSelectedDaybookData(selectedDaybookData);
      onOpenAdjustedDocs();
   };

   const handleExchange = () => {
      setShouldFetch(true);
      setTimeout(() => {
         onOpenExchangeModal();
      }, 500);
   };

   const handleSalesSave = async () => {
      const res = await dispatch(getPurchaseInvoice(editExchangeData.id));

      const exchangeData =
         res.data.lineitems?.map((item) => {
            return {
               id: item.id,
               isDeleted: false,
               isOld: item.purchaseLineDetail[0]?.isOld,
               itemId: item.purchaseLineDetail[0]?.itemId,
               itemRate: item.itemRate,
               note1: item.notes,
               purchaseId: editExchangeData.id,
               salesLineDetailId: item.purchaseLineDetail[0]?.id,
               serialNo: item.purchaseLineDetail[0]?.serialNo,
               serialNo2: item.purchaseLineDetail[0]?.serialNo2,
            };
         }) || [];

      const payments =
         res.data.vouchers?.map((payment) => {
            return {
               id: payment.id,
               daybookId: payment.daybookId,
               amount: payment.amount,
               outAdjustmentId: payment.outAdjustmentId,
            };
         }) || [];

      setExchange(exchangeData);
      setExchangePayments(payments);
      setTimeout(() => {
         handleAskToVerifyCustomer(exchangeData, payments);
      }, 1000);
   };

   const getOrderData = useCallback(async () => {
      if (daybook && daybook?.orderFieldRegion === 0) {
         await dispatch(getOrderDocument({
            ...((row.header.accountId || (id && salesInvoice)) && { accountId: (id && salesInvoice) ? salesInvoice.accountId : row.header.accountId }),
            ...(daybook?.orderdaybookid && { daybookId: daybook?.orderdaybookid }),
            ...(shouldSendCompanyIdAccount && { accountCompanyId: user?.loginhistory?.companyId, }),
            ...(shouldSendCompanyIdItem && { itemCompanyId: user?.loginhistory?.companyId, }),
         }));
      }
   }, [daybook, dispatch, salesInvoice]);

   const setLineItem = useCallback(() => {
      if (daybook && daybook?.orderFieldRegion === 0 && orderDoc?.length > 0) {
         let lineItem = [];
         if (id) {
            lineItem = orderDocument
               .filter((x) => orderDoc.includes(x.id))
               .map((i) => {
                  const item = itemData.find((x) => x.id === i.itemId);
                  const selectedAccount = accountData.find((x) => x.id === i.accountId);

                  let hsn = null;
                  if (item?.hsnData?.subHsn?.length === 1) {
                     hsn = item?.hsnData?.subHsn[0];
                  } else {
                     hsn = item?.hsnData?.subHsn?.find(
                        (h) => item.itemRate >= h.fromRate && item.itemRate <= h.toRate
                     );
                  }
                  const newGSt = Number(hsn?.gst);

                  const oldRow = salesInvoice?.lineitems?.find((x) => x.poliId === i.id);
                  const qty1 = (oldRow?.qty1 || 0) + (i.pendingQty1 || 0);
                  const qty2 = (oldRow?.qty2 || 0) + (i.pendingQty2 || 0);
                  const qty3 = (oldRow?.qty3 || 0) + (i.pendingQty3 || 0);

                  const mainqty =
                     item?.primaryuqcid === item?.uqcid1
                        ? qty1
                        : item?.primaryuqcid === item?.uqcid2
                           ? qty2
                           : qty3;

                  const amt = Number(i.itemRate) * mainqty;
                  const netGst = (amt * newGSt) / 100;

                  return {
                     ...(oldRow && { id: oldRow.id }),
                     itemId: i.itemId,
                     qty1,
                     qty2,
                     qty3,
                     itemRate: Number(i.itemRate) > 0 ? Number(i.itemRate) : '',
                     amount: amt,
                     taxableAmount: amt,
                     netAmount: amt,
                     gstPercent: i.gstPercent,
                     addLess1Percent: i.addLess1Percent,
                     addLess1Amount: i.addLess1Amount,
                     addLess2Percent: i.addLess2Percent,
                     addLess2Amount: i.addLess2Amount,
                     addLess3Percent: i.addLess3Percent,
                     addLess3Amount: i.addLess3Amount,
                     unit: item?.primaryuqcid,
                     gst: newGSt,
                     subHSNId: hsn?.id,
                     ratio: hsn?.ratio,
                     taxableAmount: amt,
                     netGst: netGst,
                     gstAmount: netGst + amt,
                     typeOfSupply: 1,
                     soliId: i.id,
                     isDeleted: false,
                     stock:
                        item?.itemdetailtype === 1
                           ? [
                              {
                                 serialNo: i.issued_serial_no,
                                 serialNo2: i.issued_serial_no2,
                                 barcode: i.barcode,
                                 note1: i.note1,
                                 isOld: i.isOld,
                                 itemId: i.itemId,
                                 itemName: i.itemName,
                                 stockId: i.stockId,
                                 issueLineDetailId: i.issue_linedetail_id,
                                 isBox: false,
                                 isBill: false,
                                 isKit: false,
                              },
                           ]
                           : [],
                  };
               });
         } else {
            lineItem = orderDocument
               .filter((x) => orderDoc.includes(x.id))
               .map((i, index) => {
                  const item = itemData.find((x) => x.id === i.itemId);
                  let hsn = null;
                  if (item?.hsnData?.subHsn.length === 1) {
                     hsn = item?.hsnData?.subHsn[0];
                  } else {
                     hsn = item?.hsnData?.subHsn.find(
                        (hsn) => item.itemRate >= hsn.fromRate && item.itemRate <= hsn.toRate,
                     );
                  }
                  const newGSt = Number(hsn?.gst);
                  const mainqty = item?.primaryuqcid === item?.uqcid1 ? i.pendingQty1 : item?.primaryuqcid === item?.uqcid2 ? i.pendingQty2 : i.pendingQty3;
                  const amt = Number(i.itemRate) * mainqty;
                  const netGst = (amt * newGSt) / 100;
                  return {
                     itemId: i.itemId,
                     qty1: i.pendingQty1 ?? 0,
                     qty2: i.pendingQty2 ?? 0,
                     qty3: i.pendingQty3 ?? 0,
                     itemRate: Number(i.itemRate) > 0 ? Number(i.itemRate) : '',
                     amount: amt,
                     taxableAmount: amt,
                     netAmount: amt,
                     gstPercent: i.gstPercent,
                     addLess1Percent: i.addLess1Percent,
                     addLess1Amount: i.addLess1Amount,
                     addLess2Percent: i.addLess2Percent,
                     addLess2Amount: i.addLess2Amount,
                     addLess3Percent: i.addLess3Percent,
                     addLess3Amount: i.addLess3Amount,
                     unit: item?.primaryuqcid,
                     gst: newGSt,
                     subHSNId: hsn?.id,
                     ratio: hsn?.ratio,
                     taxableAmount: amt,
                     netGst: netGst,
                     gstAmount: netGst + amt,
                     typeOfSupply: 1,
                     // lineNumber: index + 1,
                     soliId: i.id,
                     isDeleted: false,
                     stock:
                        item?.itemdetailtype === 1 && businessTypes?.businessType?.toUpperCase() === 'MOBILE'
                           ? [
                              {
                                 serialNo: i.issued_serial_no,
                                 serialNo2: i.issued_serial_no2,
                                 barcode: i.barcode,
                                 note1: i.note1,
                                 isOld: i.isOld,
                                 itemId: i.itemId,
                                 itemName: i.itemName,
                                 stockId: i.stockId,
                                 issueLineDetailId: i.issue_linedetail_id,
                                 isBox: false,
                                 isBill: false,
                                 isKit: false,
                              },
                           ]
                           : [],
                  };
               });
         }
         if (id) {
            if (salesInvoice.accountId === row.header.accountId) {
               setRow((prev) => {
                  let updated = (prev.lineItem || [])
                     .filter((item) => !item.soliId || (item.soliId && item.id))
                     .map((item) => ({ ...item }));

                  lineItem.forEach((newItem) => {
                     const index = updated.findIndex((x) => x.soliId === newItem.soliId);
                     if (index !== -1) {
                        // replace old data with new data
                        updated[index] = { ...updated[index], ...newItem };
                     } else {
                        updated.push(newItem);
                     }
                  });

                  updated = updated.map((item) => {
                     if (item.id && item.soliId) {
                        const original = salesInvoice?.lineitems?.find((x) => x.id === item.id);

                        if (original && !orderDoc.includes(item.soliId)) {
                           return { ...original };
                        }
                     }
                     return item;
                  });

                  return {
                     ...prev,
                     lineItem: updated,
                  };
               });
            } else {
               setRow((prev) => ({
                  ...prev,
                  lineItem: [
                     ...(prev.lineItem || []).map((item) =>
                        item.soliId
                           ? { ...item, isDeleted: true }
                           : { ...item },
                     ),
                     ...lineItem,
                  ],
               }));
            }
         } else {
            setRow((prev) => {
               const filtered = (prev.lineItem || [])
                  .filter((item) => !item.soliId && item.itemId)
                  .map((item) => ({ ...item }));

               return {
                  ...prev,
                  lineItem: [...filtered, ...lineItem],
               }
            });
         }
      }
   }, [daybook, orderDocument?.length, orderDoc, itemData?.length]);

   useEffect(() => {
      const saleInvoiceRight = Array.isArray(user?.userRights)
         ? user.userRights.find((right) => right.companyId === user?.loginhistory?.companyId)?.saleinvoice
         : null;

      if (user && !user?.isAdmin) {
         if (window.location.pathname.includes('sales/challan/add') && saleInvoiceRight) {
            if (saleInvoiceRight?.add !== true) {
               window.history.back();
            }
         } else if (window.location.pathname.includes('sales/challan/edit') && saleInvoiceRight) {
            if (saleInvoiceRight?.edit !== true) {
               window.history.back();
            }
         }
      }
   }, [user]);

   useEffect(() => {
      if (user && !user?.packageData?.[0]?.sales_invoice) {
         window.history.back();
      }
   }, [user]);

   useEffect(() => {
      if (user && user.isExpired) {
         window.history.back();
      }
   }, [user]);

   useEffect(() => {
      const handleKeyDown = (event) => {
         // Check for Ctrl+S (or Cmd+S on Mac)
         if ((event.ctrlKey || event.metaKey) && event.key === 's') {
            // Completely prevent default browser behavior
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
            // Trigger form submit
            if (!isLoading) {
               handleAskToVerifyCustomerForSales();
            }
            // Prevent any other handlers from running
            return false;
         }
      };

      // Add event listeners at multiple levels for complete coverage
      document.addEventListener('keydown', handleKeyDown, { capture: true, passive: false });
      window.addEventListener('keydown', handleKeyDown, { capture: true, passive: false });

      // Cleanup function
      return () => {
         document.removeEventListener('keydown', handleKeyDown, { capture: true });
         window.removeEventListener('keydown', handleKeyDown, { capture: true });
      };
   }, [row, isLoading]);

   useEffect(() => {
      if (selectedItem && serialWiseHistory) {
         const historyForItem = serialWiseHistory?.flatMap((data) =>
            data.items
               .filter((subdata) => subdata.item_id === selectedItem.itemId)
               .flatMap((subdata) => subdata.transactions),
         );
         setData(historyForItem);
         onOpenSerialhistory();
      }
   }, [serialWiseHistory, selectedItem, onOpenSerialhistory]);

   useEffect(() => {
      if (shouldFetch && id && salesInvoice) {
         const fetchData = async () => {
            try {
               const response = await dispatch(
                  getAdjustedDocs({
                     companyId: user?.loginhistory?.companyId,
                     spId: id,
                     daybookId: row.header.daybookId,
                     accountId: row.header.accountId,
                     type: 'SALES',
                  }),
               );
               const match = response.data.find((entry) => entry.adj_daybookname === 'PURCHASE EXCHANGE')?.adj_Id;
            } catch (error) {
               console.error('Error fetching adjusted docs:', error);
            } finally {
               setShouldFetch(false); // Reset after running
            }
         };

         fetchData();
      }
   }, [
      shouldFetch,
      id,
      user?.loginhistory?.companyId,
      salesInvoice,
      dispatch,
      row.header.daybookId,
      row.header.accountId,
   ]);

   useEffect(() => {
      getData();
   }, [getData]);

   useEffect(() => {
      if (row.header.daybookId || lastSaleDaybook?.daybookId) {
         const daybookId = lastSaleDaybook?.daybookId;
         dispatch(
            getBillTerm({
               daybookId: daybookId,
               ...(shouldSendCompanyidBillTerm && { companyIds: user?.loginhistory?.companyId }),
            }),
         );
      }
   }, [dispatch, lastSaleDaybook?.daybookId]);

   // edit data by id
   useEffect(() => {
      getSalesInvoiceData();
   }, [getSalesInvoiceData]);

   // set new create account id
   useEffect(() => {
      if (accountId) {
         setRow((prev) => ({
            ...prev,
            header: {
               ...prev.header,
               accountId: accountId,
            },
         }));
      }
   }, [accountId]);

   // set create account data
   useEffect(() => {
      handleEditValues();
   }, [handleEditValues]);

   // set last sale daybook
   useEffect(() => {
      if (!id) {
         if (lastSaleDaybook && lastSaleDaybook?.docno) {
            const currentDocNo = String(lastSaleDaybook?.docno ?? 0);
            const nextDocNo =
               salesInvoice?.daybookId === lastSaleDaybook?.daybookId
                  ? salesInvoice?.docno
                  : (parseInt(currentDocNo) + 1).toString() ?? '1';
            // const nextDocNo = (parseInt(currentDocNo) + 1).toString() ?? '1';

            const newRows = { ...row };
            newRows.header.daybookId = lastSaleDaybook.daybookId;
            newRows.header.docno = nextDocNo;

            newRows.lineItem = newRows.lineItem.map((item) => {
               return {
                  ...item,
                  typeOfSupply: SupplyTypes?.find((item) => item.id === daybook?.typeOfSupply)?.id || 1,
               };
            });
            setRow(newRows);
         } else {
            setRow((prev) => ({
               ...prev,
               header: {
                  ...prev.header,
                  docno: '1',
               },
               lineItem: prev.lineItem?.map((item) => {
                  return {
                     ...item,
                     typeOfSupply: SupplyTypes?.find((item) => item.id === daybook?.typeOfSupply)?.id || 1,
                  };
               }),
            }));
         }
      }
   }, [daybook?.typeOfSupply, id, lastSaleDaybook?.daybookId, lastSaleDaybook?.docno]);
   // daybook?.typeOfSupply,

   useEffect(() => {
      if (daybookId) {
         setDaybookId(daybookId);
         setRow((prev) => ({
            ...prev,
            header: {
               ...prev.header,
               daybookId: Number(daybookId),
            },
         }));
      }
   }, [daybookId, setDaybookId]);

   useEffect(() => {
      if (billTermData && billTermData?.length > 0 && !id) {
         const initialBillTerms = billTermData?.map((term) => {
            return {
               billTermId: term.id,
               percentage: term.percentValue || 0,
               amount: 0,
            };
         });
         setBillTerms(initialBillTerms);
      }
   }, [billTermData, id]);

   useEffect(() => {
      if (row.header.accountId) {
         const state = account?.accountaddress?.find((a) => a.name === 'billing')?.stateId;
         const companyState = company?.stateid;
         setIsSameState(state?.toString() === companyState?.toString());
      }
   }, [account?.accountaddress, company?.stateid, row.header.accountId]);

   useEffect(() => {
      const stocks = row?.lineItem
         ?.filter((x) => x.isDeleted === false)
         ?.flatMap((li) => {
            if (!li.itemId) return [];
            return li.stock;
         });

      setRow((prevRow) => ({
         ...prevRow,
         lineItem: prevRow.lineItem?.map((item) => {
            if (!item.itemId) return { ...item, stock: [] };
            return item;
         }),
      }));

      setSelectedStocks(stocks);
   }, [JSON.stringify(row.lineItem)]);

   useEffect(() => {
      setStockList(stocks);
   }, [stocks]);

   useEffect(() => {
      handlePayment();
   }, [handlePayment]);

   useEffect(() => {
      if (row.header.daybookId && user && user?.loginhistory?.companyId) {
         const daybookById = {
            id: Number(row.header.daybookId), // id must be number
            compId: String(user?.loginhistory?.companyId), // compId must be string
         };
         dispatch(getDaybookById(daybookById));
      }
   }, [dispatch, row.header.daybookId, user]);

   useEffect(() => {
      if (!id) {
         if (row.header.daybookId) {
            if (daybookRef.current) {
               daybookRef.current.focus();
            }
         }
      }
   }, [id, row.header.daybookId]);

   useEffect(() => {
      if (row.lineItem?.length > 0) prepareRowRefs(row.lineItem?.length);
   }, [row.lineItem?.length]);

   useEffect(() => {
      if (billTermData?.length > 0) prepareBillTermRowRefs(billTermData?.length);
   }, [billTermData?.length]);

   useEffect(() => {
      if (paymentData?.length > 0) preparePaymentRowRefs(paymentData?.length);
   }, [paymentData?.length]);

   useEffect(() => {
      if (!id || vouchers?.length === 0 || daybookPaymentData?.length === 0) return;

      setPaymentData((prevPaymentData) =>
         prevPaymentData.map((payment) => {
            const matchingVoucher = vouchers.find((voucher) => voucher.daybookId === payment.daybookId);
            return {
               ...payment,
               id: matchingVoucher?.id ?? null,
               amount: matchingVoucher?.amount ?? 0,
               outAdjustmentId: matchingVoucher?.outAdjustmentId ?? null,
            };
         }),
      );
   }, [id, vouchers, daybookPaymentData]);

   // useEffect(() => {
   //    if (!id) {
   //       if (row.header.daybookId) {
   //          if (daybookRef.current) {
   //             daybookRef.current.focus();
   //          }
   //       }
   //    }
   // }, [id, row.header.daybookId, isPageLoading]);

   useEffect(() => {
      if (!id && !isPageLoading) {
         const timer = setTimeout(() => {
            if (daybookRef.current) {
               daybookRef.current.focus();
            }
         }, 100);
         return () => clearTimeout(timer);
      }
   }, [id, isPageLoading]);

   useEffect(() => {
      if (companyData?.setting?.warehouseWishStock && herderview && !id) {
         setRow((prev) => {
            const currentWarehouseId = prev.header?.warehouseId;

            // Only update if warehouseId is null
            if (currentWarehouseId === null) {
               const fallbackWarehouseId = selectdaybookdata?.wareHouseId ?? companyData?.setting?.warehouseId ?? 1;

               return {
                  ...prev,
                  header: {
                     ...prev.header,
                     warehouseId: fallbackWarehouseId,
                  },
               };
            }

            // No update needed
            return prev;
         });
      }
   }, [row.header.daybookId]);

   useEffect(() => {
      if (companyData?.setting?.warehouseWishStock === true) {
         if (lineitemview === true || lineDetailview === true) {
            setRow((prev) => ({
               ...prev,
               lineItem: Array.isArray(prev.lineItem)
                  ? prev.lineItem.map((item) => ({
                     ...item,
                     warehouseId:
                        item.warehouseId === null // checks for null or undefined
                           ? selectdaybookdata?.wareHouseId !== null
                              ? selectdaybookdata?.wareHouseId
                              : companyData?.setting?.warehouseId !== null
                                 ? companyData?.setting?.warehouseId
                                 : 1
                           : item.warehouseId,
                  }))
                  : [],
            }));
         }
      }
   }, [row.header.daybookId, row.lineItem?.length]);

   useEffect(() => {
      if (!id) {
         setRow((prev) => ({
            ...prev,
            header: { ...prev.header, representativeId: user?.id },
         }));
      }
   }, [id, user?.id]);

   useEffect(() => {
      const handleKeyDown = (e) => {
         if (e.key === 'Escape') {
            const activeElement = document.activeElement;

            if (activeElement !== docNoRef.current) {
               // Focus docnoRef if not already focused
               docNoRef.current?.focus();
            } else {
               // If already focused, go back
               handleReset();
               window.history.back();
            }
         }
      };

      window.addEventListener('keydown', handleKeyDown);
      return () => {
         window.removeEventListener('keydown', handleKeyDown);
      };
   }, [handleReset]);

   useEffect(() => {
      getOrderData();
   }, [getOrderData]);

   useEffect(() => {
      setLineItem();
      return () => { };
   }, [setLineItem]);

   return (
      <>
         <Card
            flexDirection="column"
            w={{ base: '100%', md: '100%', xl: 'calc(100% - 00px)' }}
            px="0px"
            overflowX={{ sm: 'scroll', lg: 'hidden' }}
            mt="40px"
            position="relative"
            minH={'90vh'}
            maxH={'90vh'}
            overflowY={'scroll'}>
            <CardHeader>
               <Heading size="md">
                  <Flex gap={3} justifyContent="space-between" alignItems="center">
                     <Box>
                        <Flex gap={2} alignItems="center">
                           <img
                              src={back}
                              alt="Go Back"
                              width="15px"
                              onClick={() => {
                                 handleReset();
                                 window.history.back();
                              }} // Navigate to the previous page
                              style={{ cursor: 'pointer' }} // Ensure it's clickable
                           ></img>
                           {id ? 'Update' : 'Add'} Sale Challan
                           {typeof daybookbalance === 'number' && daybookbalance !== 0 && (
                              <Text
                                 as="span"
                                 fontSize="sm"
                                 fontWeight="normal"
                                 ml={2}
                                 color={daybookbalance < 0 ? 'green.500' : 'red.500'}>
                                 (Balance: ₹{Math.abs(daybookbalance)?.toFixed(2)})
                              </Text>
                           )}
                        </Flex>
                     </Box>
                     {id && salesInvoice ? (
                        <Box>
                           <Flex gap={2} alignItems="center">
                              <Heading as="h3" size="lg">
                                 {salesInvoice?.pendingamt ? `₹${salesInvoice?.pendingamt}` : ''}
                              </Heading>
                              <Badge
                                 border="1px solid"
                                 bg="transparent"
                                 borderColor={pendingPayment?.borderColor}
                                 color={pendingPayment?.badgeColor}
                                 borderRadius="md"
                                 w="100%"
                                 textAlign="center"
                                 textTransform="capitalize">
                                 {salesInvoice?.pendingstatus?.replace(/\s*\[.*?\]/, '')?.trim()}
                              </Badge>
                              <Icon
                                 as={FaCircleInfo}
                                 boxSize={4}
                                 // ml={3}
                                 color="green.600"
                                 onClick={handleAdjustedDocs}
                                 cursor="pointer"
                              />
                           </Flex>
                        </Box>
                     ) : null}
                  </Flex>
               </Heading>
            </CardHeader>
            <CardBody>
               <Box position="relative">
                  {isPageLoading ? (
                     <Flex w="full" justifyContent="center" alignItems="center">
                        <Image src={loaderAnimation} width={150} height={150} objectFit="cover" />
                     </Flex>
                  ) : (
                     <>
                        <form>
                           <Grid templateColumns="repeat(4, 1fr)" gap={6}>
                              <GridItem w="100%">
                                 {renderDynamicDropdown(
                                    'daybookId',
                                    'Daybook',
                                    filteredDaybooks,
                                    {
                                       errorName: 'header.daybookId',
                                       value: row.header.daybookId,
                                       onChange: (value) => handleDaybook('daybookId', value),
                                       focusBorderColor: 'blue.500',
                                       _focus: {
                                          boxShadow: '0 0 0 3px rgba(66, 153, 225, 0.6)',
                                       },
                                       disabled: filedDisabled,
                                       ref: daybookRef,
                                       nextRef: docNoRef,
                                       showCustomNoOptions: true,
                                       openfrom: 'salesdaybook',
                                       type: 4,
                                    },
                                    errors,
                                    textColor,
                                    false,
                                    'Select Daybook',
                                 )}
                              </GridItem>
                              <GridItem w="100%">
                                 <InputField
                                    ref={docNoRef}
                                    type="text"
                                    name="docno"
                                    label="Document Number"
                                    value={row.header.docno}
                                    onChange={(e) => handleInputChange('header', e)}
                                    onKeyDown={async (e) => {
                                       if (e.key === 'PageUp') {
                                          e.preventDefault();
                                          if (!id) {
                                             if (lastSaleDaybook?.id)
                                                navigate(`/admin/sales/challan/edit/${lastSaleDaybook?.id}`);
                                          } else {
                                             const res = await dispatch(
                                                getPrevAndNext({
                                                   id: id,
                                                   daybookId: row.header.daybookId,
                                                   companyId: user?.loginhistory?.companyId,
                                                }),
                                             );
                                             if (res.prev) {
                                                navigate(`/admin/sales/challan/edit/${res.prev}`);
                                             } else {
                                                handleReset();
                                                navigate(`/admin/sales/challan/add`);
                                             }
                                          }
                                          return;
                                       }
                                       if (e.key === 'PageDown') {
                                          e.preventDefault();
                                          if (!id) {
                                             if (lastSaleDaybook?.id)
                                                navigate(`/admin/sales/challan/edit/${lastSaleDaybook?.id}`);
                                          } else {
                                             const res = await dispatch(
                                                getPrevAndNext({
                                                   id: id,
                                                   daybookId: row.header.daybookId,
                                                   companyId: user?.loginhistory?.companyId,
                                                }),
                                             );
                                             if (res.next) {
                                                navigate(`/admin/sales/challan/edit/${res.next}`);
                                             } else {
                                                handleReset();
                                                navigate(`/admin/sales/challan/add`);
                                             }
                                          }
                                          return;
                                       }
                                       handleKeyDown(e, transactionAtRef, daybookRef);
                                    }}
                                    autoFocus={id > 0 ? true : false}
                                 />
                              </GridItem>
                              <GridItem w="100%" colSpan={2} rowSpan={2}>
                                 {account &&
                                    (account.mobile ||
                                       account.email ||
                                       account.panNo ||
                                       account.addressJson?.length > 0 ||
                                       account.gstRegNo ||
                                       account.brokername ||
                                       account.amt) ? (
                                    <Grid
                                       border="1.5px solid"
                                       borderColor="gray.200"
                                       borderRadius="15px"
                                       padding="20px"
                                       marginLeft="40px"
                                       width="80%"
                                       gap={5}>
                                       <Flex gap={5} justifyContent="space-between">
                                          {account.mobile ? (
                                             <GridItem display="flex" alignItems="center">
                                                <Image
                                                   src={phone}
                                                   alt="editicon"
                                                   boxSize="20px"
                                                   mr={2}
                                                   title="Phone Icon"
                                                />
                                                {account.mobile}
                                             </GridItem>
                                          ) : null}

                                          {account.email ? (
                                             <GridItem display="flex" alignItems="center">
                                                <Image
                                                   src={Email}
                                                   alt="editicon"
                                                   boxSize="20px"
                                                   mr={2}
                                                   title="Email Icon"
                                                />
                                                {account.email}
                                             </GridItem>
                                          ) : null}

                                          {account.panNo ? (
                                             <GridItem display="flex" alignItems="center">
                                                <Image
                                                   src={panno}
                                                   alt="editicon"
                                                   boxSize="22px"
                                                   mr={2}
                                                   title="Pan no Icon"
                                                />
                                                {account.panNo}
                                             </GridItem>
                                          ) : null}
                                       </Flex>
                                       <Flex gap={5} alignItems="start">
                                          {account.addressJson?.length > 0 ? (
                                             <GridItem display="flex" alignItems="center" maxHeight="50%">
                                                <Image
                                                   src={map}
                                                   alt="editicon"
                                                   boxSize="20px"
                                                   mr={2}
                                                   title="Billing address Icon"
                                                />
                                                {account.addressJson.map((address, index) => (
                                                   <Text key={index}>{address.address1}</Text>
                                                ))}
                                             </GridItem>
                                          ) : null}

                                          <Grid gap={5}>
                                             {account.gstRegNo ? (
                                                <GridItem display="flex" alignItems="center">
                                                   <Image
                                                      src={gstno}
                                                      alt="editicon"
                                                      boxSize="20px"
                                                      mr={2}
                                                      title="gst Icon"
                                                   />
                                                   {account.gstRegNo}
                                                </GridItem>
                                             ) : null}
                                             {account.brokername ? (
                                                <GridItem display="flex" alignItems="center">
                                                   <Image
                                                      src={Brokername}
                                                      alt="editicon"
                                                      boxSize="20px"
                                                      mr={2}
                                                      title="Broker name Icon"
                                                   />
                                                   {account.brokername}
                                                </GridItem>
                                             ) : null}

                                             {account.amt ? (
                                                <GridItem display="flex" alignItems="center">
                                                   <Image
                                                      src={Balance}
                                                      alt="editicon"
                                                      boxSize="20px"
                                                      mr={2}
                                                      title="Balance Icon"
                                                   />
                                                   {account.amt}
                                                </GridItem>
                                             ) : null}
                                          </Grid>
                                       </Flex>
                                    </Grid>
                                 ) : null}
                              </GridItem>

                              <GridItem w="100%">
                                 <InputField
                                    ref={transactionAtRef}
                                    type="date"
                                    name="transactionAt"
                                    label="Transaction Date"
                                    value={row.header.transactionAt}
                                    onChange={(e) => {
                                       let value = e.target.value; // yyyy-mm-dd

                                       const parts = value.split('-');
                                       if (parts[0]?.length > 4) {
                                          parts[0] = parts[0].slice(0, 4);
                                          value = parts.join('-');
                                       }
                                       handleInputChange('header', {
                                          target: {
                                             name: e.target.name,
                                             value,
                                          },
                                       });
                                    }}
                                    onKeyDown={(e) => handleKeyDown(e, accountRef, docNoRef)}
                                 />
                              </GridItem>
                              <GridItem w="100%">
                                 <AccountSelect
                                    ref={accountRef}
                                    name="accountId"
                                    options={accountData}
                                    label="Account"
                                    value={row.header.accountId}
                                    errors={errors}
                                    errorName="header.accountId"
                                    isClearable
                                    isSearchable
                                    isDisabled={filedDisabled}
                                    onChange={(value) => {
                                       handleAccount('accountId', value);
                                    }}
                                    onKeyDown={(e) => handleKeyDown(e, brokerRef, transactionAtRef)}
                                    showCustomNoOptions={true}
                                    openfrom="salesdaybook"
                                    glGroup={targetGlGroup}
                                 />
                              </GridItem>

                              <GridItem w="100%">
                                 {renderDynamicDropdown(
                                    'brokerId',
                                    'Broker',
                                    accountData,
                                    {
                                       errorName: 'header.brokerId',
                                       value: row.header.brokerId,
                                       onChange: (value) => handleAccount('brokerId', value),
                                       focusBorderColor: 'blue.500',
                                       _focus: {
                                          boxShadow: '0 0 0 3px rgba(66, 153, 225, 0.6)',
                                       },
                                       ref: brokerRef,
                                       nextRef: supplierRef,
                                       preRef: accountRef,
                                       showCustomNoOptions: true,
                                       openfrom: 'account',
                                    },
                                    errors,
                                    textColor,
                                    false,
                                    'Select Broker',
                                 )}
                              </GridItem>

                              <GridItem w="100%">
                                 {renderDynamicDropdown(
                                    'representativeId',
                                    'Saleman',
                                    salesManList,
                                    {
                                       errorName: 'header.representativeId',
                                       value: row.header.representativeId,
                                       onChange: (value) => handleAccount('representativeId', value),
                                       focusBorderColor: 'blue.500',
                                       _focus: {
                                          boxShadow: '0 0 0 3px rgba(66, 153, 225, 0.6)',
                                       },
                                       ref: supplierRef,
                                       // nextRef: wareHouseRef,
                                       preRef: brokerRef,
                                       onKeyDown: (e) => {
                                          e.preventDefault();
                                          if (daybook?.isAskIncomeExpenses) {
                                             handleKeyDown(e, incomeRef, brokerRef);
                                             return;
                                          }

                                          if (
                                             companyData?.setting?.warehouseWishStock === true &&
                                             herderview === true
                                          ) {
                                             handleKeyDown(e, wareHouseRef, brokerRef);
                                             return;
                                          }

                                          if (daybook && daybook?.orderFieldRegion === 0) {
                                             handleKeyDown(e, orderDocRef, brokerRef);
                                             return;
                                          }

                                          if (itemRefs?.current[0]) {
                                             itemRefs?.current[0]?.focus();
                                             return;
                                          }
                                          if (e.key === 'Enter' || e.key === 'Tab') {
                                             if (
                                                companyData?.setting?.warehouseWishStock === true &&
                                                (lineitemview === true || lineDetailview === true)
                                             ) {
                                                warehouseRef?.current[0]?.focus();
                                             } else {
                                                itemRefs?.current[0]?.focus();
                                             }
                                          }
                                       },
                                       showCustomNoOptions: true,
                                       openfrom: 'Saleman',
                                    },
                                    errors,
                                    textColor,
                                    false,
                                    'Select Saleman',
                                 )}
                              </GridItem>

                              {daybook?.isAskIncomeExpenses ? (
                                 <GridItem w="100%">
                                    <AccountSelect
                                       ref={incomeRef}
                                       name="incomeId"
                                       options={incomeAccounts}
                                       label="Income Account"
                                       value={row.header.incomeId}
                                       errors={errors}
                                       errorName="header.incomeId"
                                       isClearable
                                       isSearchable
                                       onChange={(value) => {
                                          handleAccount('incomeId', value);
                                       }}
                                       onKeyDown={(e) => {
                                          if (
                                             companyData?.setting?.warehouseWishStock === true &&
                                             herderview === true
                                          ) {
                                             handleKeyDown(e, wareHouseRef, brokerRef);
                                             return;
                                          }

                                          if (daybook && daybook?.orderFieldRegion === 0) {
                                             handleKeyDown(e, orderDocRef, brokerRef);
                                             return;
                                          }

                                          if (itemRefs?.current[0]) {
                                             itemRefs?.current[0]?.focus();
                                             return;
                                          }
                                       }}
                                       showCustomNoOptions={true}
                                       openfrom="salesdaybook"
                                       glGroup={targetGlGroup}
                                    />
                                 </GridItem>
                              ) : null}

                              {companyData?.setting?.warehouseWishStock === true && herderview === true && (
                                 <GridItem className="seperator-width">
                                    {renderDynamicDropdown(
                                       'warehouseId',
                                       'Ware House',
                                       warehouseList,
                                       {
                                          value: row.header.warehouseId,
                                          onChange: (value) => handleAccount('warehouseId', value),
                                          showCustomNoOptions: true,
                                          openfrom: 'wareHouse',
                                          ref: wareHouseRef,
                                          onKeyDown: (e) => {
                                             if (e.key === 'Enter' || e.key === 'Tab') {
                                                e.preventDefault();
                                                if (e.shiftKey) {
                                                   if (daybook?.isAskIncomeExpenses) {
                                                      incomeRef?.current?.focus();
                                                   } else {
                                                      supplierRef?.current?.focus();
                                                   }
                                                } else {
                                                   if (daybook && daybook?.orderFieldRegion === 0) {
                                                      handleKeyDown(e, orderDocRef, brokerRef);
                                                      return;
                                                   }

                                                   if (itemRefs?.current[0]) {
                                                      itemRefs?.current[0]?.focus();
                                                      return;
                                                   }
                                                }
                                             }
                                          },
                                       },
                                       errors,
                                       textColor,
                                       false,
                                       'Select Ware House',
                                    )}
                                 </GridItem>
                              )}

                              {daybook && daybook?.orderFieldRegion === 0 ? (
                                 <GridItem w="100%">
                                    {dynamicDropdown(
                                       'orderDoc',
                                       'Order Document',
                                       orderDocument?.map((x) => ({
                                          label: `${x.itemName} ${x.docNo ? `( ${x.docNo} )` : ''} ${x.accountName ? `( ${x.accountName} )` : ''} ${x.pendingQty1 ? `(Qty 1 :- ${x.pendingQty1})` : ''} ${x.pendingQty2 ? `(Qty 2 :- ${x.pendingQty2})` : ''} ${x.pendingQty3 ? `(Qty 3 :- ${x.pendingQty3})` : ''}`,
                                          id: x.id,
                                       })),
                                       {
                                          errorName: 'header.orderDoc',
                                          value: orderDoc,
                                          onChange: (value) => {
                                             setOrderDoc(value);
                                             if (value?.length === 0) {
                                                if (id) {
                                                   setRow((prev) => {
                                                      const filtered = (prev.lineItem || [])
                                                         .filter((item) => !item.soliId || (item.soliId && item.id))
                                                         .map((item) => {
                                                            if (item.id && item.poliId) {
                                                               const original = salesInvoice?.lineitems?.find((x) => x.id === item.id);
                                                               if (original) {
                                                                  return { ...original, unit: original?.ratePer, isDeleted: false, gst: original?.gstPercent, gstAmount: original?.amount + original?.netGst };
                                                               }
                                                            }
                                                            return { ...item };
                                                         });

                                                      return {
                                                         ...prev,
                                                         lineItem: filtered.length > 0 ? filtered : [initialLineItem],
                                                      }
                                                   });
                                                } else {
                                                   setRow((prev) => {
                                                      const filtered = (prev.lineItem || [])
                                                         .filter((item) => !item.soliId && item.itemId)
                                                         .map((item) => ({ ...item }));

                                                      return {
                                                         ...prev,
                                                         lineItem: filtered.length > 0 ? filtered : [initialLineItem],
                                                      }
                                                   });
                                                }
                                             }
                                             if (row.header.accountId) {
                                             } else if (value?.length === 1) {
                                                const findData = orderDocument.filter(
                                                   (data) => data.id === value[0],
                                                );
                                                if (findData?.length > 0) {
                                                   handleAccount('accountId', findData[0].accountId);
                                                   accountRef.current.focus();
                                                }
                                             }
                                          },
                                          focusBorderColor: 'blue.500',
                                          _focus: {
                                             boxShadow: '0 0 0 3px rgba(66, 153, 225, 0.6)',
                                          },
                                          ref: orderDocRef,
                                          nextRef: itemRefs?.current[0],
                                          onKeyDown: (e) => {
                                             if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                                e.preventDefault();

                                                if (itemRefs?.current[0]) {
                                                   itemRefs?.current[0]?.focus();
                                                   return;
                                                }
                                             }
                                          },
                                          showCustomNoOptions: true,
                                          openfrom: 'account',
                                       },
                                       errors,
                                       textColor,
                                       false,
                                       'Select Broker',
                                       true, // isSearchable
                                       undefined, // filteredOptions
                                       true, // isMulti
                                    )}
                                 </GridItem>
                              ) : null}
                           </Grid>

                           <Grid templateColumns="repeat(4, 1fr)" gap={6}>
                              <GridItem w="100%" colSpan={4}>
                                 <Box my={3}>
                                    <LineItem
                                       addLineItem={addLineItem}
                                       lineItems={row.lineItem}
                                       itemData={itemData}
                                       textColor={textColor}
                                       lastDaybook={daybook}
                                       removeLineItem={removeLineItem}
                                       handleOnChange={handleOnChange}
                                       companyData={companyList}
                                       totals={totals}
                                       handleStockModalOnClick={handleStockModalOnClick}
                                       errors={errors}
                                       refs={refs}
                                       prerefs={
                                          daybook && daybook?.orderFieldRegion === 0
                                             ? orderDocRef
                                             : companyData?.setting?.warehouseWishStock === true && herderview === true
                                                ? wareHouseRef
                                                : daybook?.isAskIncomeExpenses
                                                   ? incomeRef
                                                   : supplierRef
                                       }
                                       setCurrentLineItemIdx={setCurrentLineItemIdx}
                                       warehouseList={warehouseList}
                                       lineitemview={lineitemview === true ? lineitemview : lineDetailview}
                                       selectcompany={companyData}
                                       billTermData={billTermData}
                                    />
                                 </Box>
                              </GridItem>
                           </Grid>

                           <Grid templateRows="repeat(1, 1fr)" templateColumns="repeat(4, 1fr)" gap={3}>
                              <GridItem w="100%" colSpan={2}>
                                 <Grid templateColumns="repeat(2, 1fr)" gap={3}>
                                    <GridItem w="100%">
                                       <InputField
                                          ref={dueDaysRef}
                                          type="number"
                                          name="dueDays"
                                          label="Due Days"
                                          value={row.header.dueDays}
                                          onChange={(e) => handleInputChange('header', e)}
                                          onKeyDown={(e) => {
                                             if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                                e.preventDefault();
                                             }
                                             if (e.key === 'Tab' && e.shiftKey) {
                                                if (refs?.amountRefs?.current) {
                                                   const lastIndex = refs.amountRefs?.current?.length - 1;
                                                   refs.amountRefs.current[lastIndex]?.focus();
                                                }
                                             }
                                             handleKeyDown(e, dueDateRef);
                                          }}
                                          onWheel={(e) => e.target.blur()}
                                       />
                                    </GridItem>
                                    <GridItem w="100%">
                                       <InputField
                                          ref={dueDateRef}
                                          type="date"
                                          name="dueAt"
                                          label="Due Date"
                                          value={row.header.dueAt}
                                          onChange={(e) => handleInputChange('header', e)}
                                          onKeyDown={(e) => handleKeyDown(e, transportRef, dueDaysRef)}
                                       />
                                    </GridItem>

                                    <GridItem w="100%">
                                       {renderDynamicDropdown(
                                          'transportId',
                                          'Transport',
                                          transportList,
                                          {
                                             errorName: 'header.transportId',
                                             value: row.header.transportId,
                                             onChange: (value) => handleAccount('transportId', value),
                                             focusBorderColor: 'blue.500',
                                             _focus: {
                                                boxShadow: '0 0 0 3px rgba(66, 153, 225, 0.6)',
                                             },
                                             ref: transportRef,
                                             nextRef: vehicleRef,
                                             preRef: dueDateRef,
                                             showCustomNoOptions: true,
                                             openfrom: 'transport',
                                          },
                                          errors,
                                          textColor,
                                          false,
                                          'Select Transport',
                                       )}
                                    </GridItem>
                                    <GridItem w="100%">
                                       {renderDynamicDropdown(
                                          'vehicleId',
                                          'Vehicle',
                                          vehicleList,
                                          {
                                             errorName: 'header.vehicleId',
                                             value: row.header.vehicleId,
                                             onChange: (value) => handleAccount('vehicleId', value),
                                             focusBorderColor: 'blue.500',
                                             _focus: {
                                                boxShadow: '0 0 0 3px rgba(66, 153, 225, 0.6)',
                                             },
                                             ref: vehicleRef,
                                             nextRef: notesRef,
                                             preRef: transportRef,
                                             showCustomNoOptions: true,
                                             openfrom: 'vehicle',
                                          },
                                          errors,
                                          textColor,
                                          false,
                                          'Select Vehicle',
                                       )}
                                    </GridItem>

                                    <GridItem w="100%" colSpan={2}>
                                       <TextareaField
                                          ref={notesRef}
                                          name="notes"
                                          label="Notes"
                                          value={row.header.notes}
                                          onChange={(e) => handleInputChange('header', e)}
                                          onKeyDown={(e) => {
                                             if (e.key === 'Enter' && !e.shiftKey) {
                                                e.preventDefault();
                                                if (paymentData?.length > 0) {
                                                   paymentRefs?.current[0]?.focus();
                                                } else {
                                                   if (submitRef.current) {
                                                      submitRef.current.focus();
                                                   }
                                                }
                                             }
                                             if (e.key === 'Tab') {
                                                e.preventDefault();
                                                if (e.shiftKey) {
                                                   if (vehicleRef?.current) {
                                                      vehicleRef?.current?.focus();
                                                   }
                                                } else {
                                                   if (paymentData?.length > 0) {
                                                      paymentRefs?.current[0]?.focus();
                                                   } else {
                                                      if (submitRef.current) {
                                                         submitRef.current.focus();
                                                      }
                                                   }
                                                }
                                             }
                                          }}
                                       />
                                    </GridItem>

                                    <GridItem w="100%" colSpan={2}>
                                       {selectedStocks?.length > 0 ? (
                                          <TableContainer
                                             border="1px"
                                             borderColor="gray.200"
                                             borderRadius={5}
                                             maxH="300px"
                                             overflowY="auto">
                                             <Table variant="simple" size="sm">
                                                <Thead bg="gray.200">
                                                   <Tr>
                                                      <Th>Item</Th>
                                                      <Th>Series No</Th>
                                                      <Th>Warehouse</Th>
                                                      <Th>Action</Th>
                                                   </Tr>
                                                </Thead>
                                                <Tbody>
                                                   {selectedStocks &&
                                                      selectedStocks?.map((item, index) => {
                                                         return (
                                                            <Tr key={index}>
                                                               <Td>{item?.itemName}</Td>
                                                               <Td>
                                                                  {item?.serialNo}
                                                                  <Icon
                                                                     as={FaHistory}
                                                                     boxSize={4}
                                                                     ml={3}
                                                                     color="green.600"
                                                                     onClick={() => handleSerialHistory(item)}
                                                                     cursor="pointer"
                                                                  />
                                                               </Td>
                                                               <Td>{item?.warehouseName}</Td>
                                                               <Td>
                                                                  <IconButton
                                                                     colorScheme="red"
                                                                     size="sm"
                                                                     onClick={() => removeStock(item)}
                                                                     icon={<FaTrash />}
                                                                  />
                                                               </Td>
                                                            </Tr>
                                                         );
                                                      })}
                                                </Tbody>
                                             </Table>
                                          </TableContainer>
                                       ) : null}
                                    </GridItem>

                                    <GridItem w="100%" colSpan={2}>
                                       <Grid templateColumns="repeat(2, 1fr)" gap={3}>
                                          {paymentData?.map((payment, idx) => {
                                             return (
                                                <GridItem w="100%" key={idx}>
                                                   <InputField
                                                      ref={(el) => {
                                                         if (paymentRefs && paymentRefs.current) {
                                                            paymentRefs.current[idx] = el;
                                                         }
                                                      }}
                                                      type="number"
                                                      name={`amount`}
                                                      label={`${payment.daybookName} AMOUNT`}
                                                      value={payment.amount}
                                                      onChange={(e) => handlePaymentOnChange(e, idx)}
                                                      onKeyDown={(e) => {
                                                         if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                                            e.preventDefault();
                                                         }
                                                         if (e.key === 'Enter') {
                                                            e.preventDefault();
                                                            if (paymentRefs?.current[idx + 1]) {
                                                               paymentRefs?.current[idx + 1].focus();
                                                            } else {
                                                               if (submitRef.current) {
                                                                  submitRef.current.focus();
                                                               }
                                                            }
                                                         }

                                                         if (e.key === 'Tab') {
                                                            e.preventDefault();
                                                            if (e.shiftKey) {
                                                               if (paymentRefs?.current[idx - 1]) {
                                                                  paymentRefs?.current[idx - 1].focus();
                                                               } else {
                                                                  if (notesRef.current) {
                                                                     notesRef.current.focus();
                                                                  }
                                                               }
                                                            } else {
                                                               if (paymentRefs?.current[idx + 1]) {
                                                                  paymentRefs?.current[idx + 1].focus();
                                                               } else {
                                                                  if (submitRef.current) {
                                                                     submitRef.current.focus();
                                                                  }
                                                               }
                                                            }
                                                         }
                                                      }}
                                                      onWheel={(e) => e.target.blur()}
                                                   />
                                                </GridItem>
                                             );
                                          })}
                                       </Grid>
                                    </GridItem>

                                    {daybook?.ewayBill &&
                                       daybook?.applyGst &&
                                       company?.setting?.ewayBill &&
                                       company?.setting?.eWayUserName &&
                                       company?.setting?.eWayPassword &&
                                       !id ? (
                                       <GridItem w="100%">
                                          <Box mb={3}>
                                             {renderSwitchControl(
                                                'ewayBill ',
                                                'E-Way Bill ',
                                                {
                                                   isChecked: isEWayBill,
                                                   onChange: (e) => setIsEWayBill(e.target.checked),
                                                },
                                                errors,
                                                textColor,
                                                false,
                                                id ? true : false,
                                             )}
                                          </Box>
                                       </GridItem>
                                    ) : null}

                                    {daybook?.ewayBill &&
                                       daybook?.applyGst &&
                                       company?.setting?.ewayBill &&
                                       company?.setting?.eWayUserName &&
                                       company?.setting?.eWayPassword &&
                                       salesInvoice?.ewayBillno &&
                                       id ? (
                                       <GridItem w="100%">
                                          <Box mb={3}>
                                             <InputField
                                                type="text"
                                                name="ewayBillno"
                                                label="E-Way Bill No"
                                                value={salesInvoice?.ewayBillno || ''}
                                                isDisabled
                                             />
                                          </Box>
                                       </GridItem>
                                    ) : null}

                                    {daybook?.ewayBill &&
                                       daybook?.applyGst &&
                                       company?.setting?.ewayBill &&
                                       company?.setting?.eWayUserName &&
                                       company?.setting?.eWayPassword &&
                                       salesInvoice?.ewayBillCanceldate &&
                                       id ? (
                                       <GridItem w="100%">
                                          <Box mb={3}>
                                             <InputField
                                                type="text"
                                                name="ewayBillCanceldate"
                                                label="E-Way Bill Cancel Date"
                                                value={eBillDateFormat(salesInvoice?.ewayBillCanceldate) || ''}
                                                isDisabled
                                             />
                                          </Box>
                                       </GridItem>
                                    ) : null}

                                    {daybook?.ewayBill &&
                                       daybook?.applyGst &&
                                       company?.setting?.ewayBill &&
                                       company?.setting?.eWayUserName &&
                                       company?.setting?.eWayPassword &&
                                       salesInvoice?.ewayBillDate &&
                                       id ? (
                                       <GridItem w="100%">
                                          <Box mb={3}>
                                             <InputField
                                                type="text"
                                                name="ewayBillDate"
                                                label="E-Way Bill Date"
                                                value={eBillDateFormat(salesInvoice?.ewayBillDate) || ''}
                                                isDisabled
                                             />
                                          </Box>
                                       </GridItem>
                                    ) : null}

                                    {daybook?.ewayInvoice &&
                                       daybook?.applyGst &&
                                       company?.setting?.ewayInvoice &&
                                       company?.setting?.eInvoiceUserName &&
                                       company?.setting?.eInvoicePassword &&
                                       !id ? (
                                       <GridItem w="100%">
                                          <Box mb={3}>
                                             {renderSwitchControl(
                                                'ewayInvoice ',
                                                'E-Invoice',
                                                {
                                                   isChecked: isEInvoice,
                                                   onChange: (e) => setIsEInvoice(e.target.checked),
                                                },
                                                errors,
                                                textColor,
                                                false,
                                                id ? true : false,
                                             )}
                                          </Box>
                                       </GridItem>
                                    ) : null}

                                    {daybook?.ewayInvoice &&
                                       daybook?.applyGst &&
                                       company?.setting?.ewayInvoice &&
                                       company?.setting?.eInvoiceUserName &&
                                       company?.setting?.eInvoicePassword &&
                                       salesInvoice?.einvoiceackno &&
                                       id ? (
                                       <GridItem w="100%">
                                          <Box mb={3}>
                                             <InputField
                                                type="text"
                                                name="einvoiceackno"
                                                label="E-Inv. Ack. No"
                                                value={salesInvoice?.einvoiceackno || ''}
                                                isDisabled
                                             />
                                          </Box>
                                       </GridItem>
                                    ) : null}

                                    {daybook?.ewayInvoice &&
                                       daybook?.applyGst &&
                                       company?.setting?.ewayInvoice &&
                                       company?.setting?.eInvoiceUserName &&
                                       company?.setting?.eInvoicePassword &&
                                       salesInvoice?.einvoiceackdate &&
                                       id ? (
                                       <GridItem w="100%">
                                          <Box mb={3}>
                                             <InputField
                                                type="text"
                                                name="einvoiceackdate"
                                                label="E-Inv. Ack. Date"
                                                value={eBillDateFormat(salesInvoice?.einvoiceackdate) || ''}
                                                isDisabled
                                             />
                                          </Box>
                                       </GridItem>
                                    ) : null}

                                    {daybook?.ewayInvoice &&
                                       daybook?.applyGst &&
                                       company?.setting?.ewayInvoice &&
                                       company?.setting?.eInvoiceUserName &&
                                       company?.setting?.eInvoicePassword &&
                                       salesInvoice?.einvoiceCancelDate &&
                                       id ? (
                                       <GridItem w="100%">
                                          <Box mb={3}>
                                             <InputField
                                                type="text"
                                                name="einvoiceCancelDate"
                                                label="E-Inv. Cancel Date"
                                                value={salesInvoice?.einvoiceCancelDate || ''}
                                                isDisabled
                                             />
                                          </Box>
                                       </GridItem>
                                    ) : null}

                                    {daybook?.ewayInvoice &&
                                       daybook?.applyGst &&
                                       company?.setting?.ewayInvoice &&
                                       company?.setting?.eInvoiceUserName &&
                                       company?.setting?.eInvoicePassword &&
                                       salesInvoice?.einvoiceirn &&
                                       id ? (
                                       <GridItem w="100%" colSpan={2}>
                                          <Box mb={3}>
                                             <InputField
                                                type="text"
                                                name="einvoiceirn"
                                                label="E-Inv. IRN. No"
                                                value={salesInvoice?.einvoiceirn || ''}
                                                isDisabled
                                             />
                                          </Box>
                                       </GridItem>
                                    ) : null}
                                 </Grid>
                              </GridItem>
                              <GridItem w="100%" colSpan={2} rowSpan={2}>
                                 <Grid templateRows="repeat(1, 1fr)" templateColumns="repeat(2, 1fr)" gap={3}>
                                    <GridItem colSpan={2}>
                                       <BillTerm
                                          textColor={textColor}
                                          billTermData={row.header.daybookId > 0 ? billTermData : []}
                                          billTerms={row.header.daybookId > 0 ? billTerms : []}
                                          netAmount={totals.netAmount}
                                          handleBillTermChange={handleBillTermChange}
                                          refs={refs}
                                       />
                                    </GridItem>
                                    <GridItem w="100%" colSpan={2}>
                                       <TaxableAmount
                                          totals={totals}
                                          isSameState={isSameState}
                                          finalNetAmount={finalNetAmount}
                                          daybook={filteredDaybooks.find((item) => item.id === row?.header?.daybookId)}
                                          company={company}
                                       />
                                    </GridItem>
                                 </Grid>
                              </GridItem>
                           </Grid>
                        </form>
                        <CardFooter justifyContent="flex-end" gap={3}>
                           {daybook?.ewayInvoice &&
                              daybook?.applyGst &&
                              company?.setting?.ewayInvoice &&
                              company?.setting?.eInvoiceUserName &&
                              company?.setting?.eInvoicePassword &&
                              id &&
                              salesInvoice?.einvoiceackno == null &&
                              salesInvoice?.einvoiceCancel == null ? (
                              <Button
                                 ref={geberateeinvoiceRef}
                                 colorScheme="green"
                                 onClick={() => {
                                    dispatch(generateEInvoice({ id: Number(id), type: 'sales' }));
                                    dispatch(getSaleChallanById(id));
                                 }}
                                 _focus={{}}
                                 onKeyDown={(e) => {
                                    if (e.key === 'ArrowRight') {
                                       e.preventDefault();
                                       if (
                                          company?.setting?.eInvoiceUserName &&
                                          company?.setting?.eInvoicePassword &&
                                          salesInvoice?.einvoiceackno != null &&
                                          salesInvoice?.einvoiceCancelDate == null
                                       ) {
                                          canceleinvoiceRef.current?.focus();
                                       } else if (
                                          daybook?.ewayBill &&
                                          daybook?.applyGst &&
                                          ((company?.setting?.ewayBill &&
                                             company.setting.eWayUserName != null &&
                                             company.setting.eWayPassword != null &&
                                             salesInvoice?.ewaybillno == null) ||
                                             (salesInvoice?.ewayBillno == null &&
                                                salesInvoice?.ewayBillCanceldate != null))
                                       ) {
                                          generateewaybillRef.current?.focus();
                                       } else if (
                                          company?.setting?.eWayUserName &&
                                          company?.setting?.eWayPassword &&
                                          id &&
                                          salesInvoice?.ewaybillno != null &&
                                          salesInvoice?.ewayBillCanceldate == null
                                       ) {
                                          cancelewaybillRef.current?.focus();
                                       } else if (daybook && daybook?.isAllowExchange) {
                                          exchangeRef.current?.focus();
                                       } else {
                                          submitRef.current?.focus();
                                       }
                                    }
                                 }}>
                                 Generate E-Invoice
                              </Button>
                           ) : null}

                           {company?.setting?.eInvoiceUserName &&
                              company?.setting?.eInvoicePassword &&
                              salesInvoice?.einvoiceackno != null &&
                              salesInvoice?.einvoiceCancelDate == null ? (
                              <Button
                                 ref={canceleinvoiceRef}
                                 colorScheme="red"
                                 onClick={() => {
                                    dispatch(cancelEInvoice({ id: Number(id), type: 'sales' }));
                                    dispatch(getSaleChallanById(id));
                                 }}
                                 _focus={{}}
                                 onKeyDown={(e) => {
                                    if (e.key === 'ArrowRight') {
                                       e.preventDefault();
                                       if (
                                          daybook?.ewayBill &&
                                          daybook?.applyGst &&
                                          ((company?.setting?.ewayBill &&
                                             company.setting.eWayUserName != null &&
                                             company.setting.eWayPassword != null &&
                                             salesInvoice?.ewaybillno == null) ||
                                             (salesInvoice?.ewayBillno == null &&
                                                salesInvoice?.ewayBillCanceldate != null))
                                       ) {
                                          generateewaybillRef.current?.focus();
                                       } else if (
                                          company?.setting?.eWayUserName &&
                                          company?.setting?.eWayPassword &&
                                          id &&
                                          salesInvoice?.ewaybillno != null &&
                                          salesInvoice?.ewayBillCanceldate == null
                                       ) {
                                          cancelewaybillRef.current?.focus();
                                       } else if (daybook && daybook?.isAllowExchange) {
                                          exchangeRef.current?.focus();
                                       } else {
                                          submitRef.current?.focus();
                                       }
                                    } else if (e.key === 'ArrowLeft') {
                                       e.preventDefault();
                                       if (
                                          daybook?.ewayInvoice &&
                                          daybook?.applyGst &&
                                          company?.setting?.ewayInvoice &&
                                          company?.setting?.eInvoiceUserName &&
                                          company?.setting?.eInvoicePassword &&
                                          id &&
                                          salesInvoice?.einvoiceackno == null &&
                                          salesInvoice?.einvoiceCancel == null
                                       ) {
                                          geberateeinvoiceRef.current?.focus();
                                       }
                                    }
                                 }}>
                                 Cancel E-Invoice
                              </Button>
                           ) : null}

                           {daybook?.ewayBill &&
                              daybook?.applyGst &&
                              ((company?.setting?.ewayBill &&
                                 company.setting.eWayUserName != null &&
                                 company.setting.eWayPassword != null &&
                                 salesInvoice?.ewaybillno == null) ||
                                 (salesInvoice?.ewayBillno == null && salesInvoice?.ewayBillCanceldate != null)) ? (
                              <Button
                                 ref={generateewaybillRef}
                                 colorScheme="green"
                                 onClick={() => {
                                    dispatch(generateEWayBill({ id: Number(id), type: 'sales' }));
                                    dispatch(getSaleChallanById(id));
                                 }}
                                 _focus={{}}
                                 onKeyDown={(e) => {
                                    if (e.key === 'ArrowRight') {
                                       e.preventDefault();
                                       if (
                                          company?.setting?.eWayUserName &&
                                          company?.setting?.eWayPassword &&
                                          id &&
                                          salesInvoice?.ewaybillno != null &&
                                          salesInvoice?.ewayBillCanceldate == null
                                       ) {
                                          cancelewaybillRef.current?.focus();
                                       } else if (daybook && daybook?.isAllowExchange) {
                                          exchangeRef.current?.focus();
                                       } else {
                                          submitRef.current?.focus();
                                       }
                                    } else if (e.key === 'ArrowLeft') {
                                       e.preventDefault();
                                       if (
                                          company?.setting?.eInvoiceUserName &&
                                          company?.setting?.eInvoicePassword &&
                                          salesInvoice?.einvoiceackno != null &&
                                          salesInvoice?.einvoiceCancelDate == null
                                       ) {
                                          canceleinvoiceRef.current?.focus();
                                       } else if (
                                          daybook?.ewayInvoice &&
                                          daybook?.applyGst &&
                                          company?.setting?.ewayInvoice &&
                                          company?.setting?.eInvoiceUserName &&
                                          company?.setting?.eInvoicePassword &&
                                          id &&
                                          salesInvoice?.einvoiceackno == null &&
                                          salesInvoice?.einvoiceCancel == null
                                       ) {
                                          geberateeinvoiceRef.current?.focus();
                                       }
                                    }
                                 }}>
                                 Generate E-Way Bill
                              </Button>
                           ) : null}

                           {company?.setting?.eWayUserName &&
                              company?.setting?.eWayPassword &&
                              id &&
                              salesInvoice?.ewaybillno != null &&
                              salesInvoice?.ewayBillCanceldate == null ? (
                              <Button
                                 ref={cancelewaybillRef}
                                 colorScheme="red"
                                 onClick={() => {
                                    dispatch(cancelEWayBill({ id: Number(id), type: 'sales' }));
                                    dispatch(getSaleChallanById(id));
                                 }}
                                 _focus={{}}
                                 onKeyDown={(e) => {
                                    if (e.key === 'ArrowRight') {
                                       e.preventDefault();
                                       if (daybook && daybook?.isAllowExchange) {
                                          exchangeRef.current?.focus();
                                       } else {
                                          submitRef.current?.focus();
                                       }
                                    } else if (e.key === 'ArrowLeft') {
                                       e.preventDefault();
                                       if (
                                          daybook?.ewayBill &&
                                          daybook?.applyGst &&
                                          ((company?.setting?.ewayBill &&
                                             company.setting.eWayUserName != null &&
                                             company.setting.eWayPassword != null &&
                                             salesInvoice?.ewaybillno == null) ||
                                             (salesInvoice?.ewayBillno == null &&
                                                salesInvoice?.ewayBillCanceldate != null))
                                       ) {
                                          generateewaybillRef.current?.focus();
                                       } else if (
                                          company?.setting?.eInvoiceUserName &&
                                          company?.setting?.eInvoicePassword &&
                                          salesInvoice?.einvoiceackno != null &&
                                          salesInvoice?.einvoiceCancelDate == null
                                       ) {
                                          canceleinvoiceRef.current?.focus();
                                       } else if (
                                          daybook?.ewayInvoice &&
                                          daybook?.applyGst &&
                                          company?.setting?.ewayInvoice &&
                                          company?.setting?.eInvoiceUserName &&
                                          company?.setting?.eInvoicePassword &&
                                          id &&
                                          salesInvoice?.einvoiceackno == null &&
                                          salesInvoice?.einvoiceCancel == null
                                       ) {
                                          geberateeinvoiceRef.current?.focus();
                                       }
                                    }
                                 }}>
                                 Cancel E-Way Bill
                              </Button>
                           ) : null}

                           <Button
                              ref={submitRef}
                              colorScheme="green"
                              fontSize="sm"
                              fontWeight="500"
                              borderRadius="full"
                              _active={{ bg: '#06b' }}
                              onClick={() => {
                                 if (id && editExchangeData?.id) {
                                    handleSalesSave();
                                 } else {
                                    handleAskToVerifyCustomerForSales();
                                 }
                              }}
                              isLoading={isLoading}
                              disabled={isLoading}
                              _focus={{ outlineColor: 'blue.500 ' }}
                              loadingText={id ? 'Updating...' : 'Saving...'}
                              onKeyDown={(e) => {
                                 if (e.key === 'ArrowRight') {
                                    e.preventDefault();
                                    closeRef.current?.focus();
                                 } else if (e.key === 'ArrowLeft' || (e.key === 'Tab' && e.shiftKey)) {
                                    e.preventDefault();
                                    if (
                                       company?.setting?.eWayUserName &&
                                       company?.setting?.eWayPassword &&
                                       id &&
                                       salesInvoice?.ewaybillno != null &&
                                       salesInvoice?.ewayBillCanceldate == null
                                    ) {
                                       cancelewaybillRef.current?.focus();
                                    } else if (
                                       daybook?.ewayBill &&
                                       daybook?.applyGst &&
                                       ((company?.setting?.ewayBill &&
                                          company.setting.eWayUserName != null &&
                                          company.setting.eWayPassword != null &&
                                          salesInvoice?.ewaybillno == null) ||
                                          (salesInvoice?.ewayBillno == null &&
                                             salesInvoice?.ewayBillCanceldate != null))
                                    ) {
                                       generateewaybillRef.current?.focus();
                                    } else if (
                                       company?.setting?.eInvoiceUserName &&
                                       company?.setting?.eInvoicePassword &&
                                       salesInvoice?.einvoiceackno != null &&
                                       salesInvoice?.einvoiceCancelDate == null
                                    ) {
                                       canceleinvoiceRef.current?.focus();
                                    } else if (
                                       daybook?.ewayInvoice &&
                                       daybook?.applyGst &&
                                       company?.setting?.ewayInvoice &&
                                       company?.setting?.eInvoiceUserName &&
                                       company?.setting?.eInvoicePassword &&
                                       id &&
                                       salesInvoice?.einvoiceackno == null &&
                                       salesInvoice?.einvoiceCancel == null
                                    ) {
                                       geberateeinvoiceRef.current?.focus();
                                    } else if (e.key === 'Tab' && e.shiftKey) {
                                       if (paymentData?.length > 0) {
                                          paymentRefs?.current[paymentData?.length - 1]?.focus();
                                       } else {
                                          notesRef.current?.focus();
                                       }
                                    }
                                 }
                              }}>
                              {id ? 'Update' : 'Save'}
                           </Button>
                           <Button
                              ref={closeRef}
                              colorScheme="red"
                              onClick={() => {
                                 handleReset();
                                 navigate('/admin/sales/challan');
                              }}
                              _focus={{ outlineColor: 'blue.500 ' }}
                              onKeyDown={(e) => {
                                 if (e.key === 'ArrowLeft') {
                                    e.preventDefault();
                                    submitRef.current?.focus();
                                 }
                              }}>
                              Cancel
                           </Button>
                        </CardFooter>
                     </>
                  )}
               </Box>
            </CardBody>
         </Card>

         {/* Serial number modal */}
         <SerialNumberModal
            isOpen={isOpenModal}
            onClose={onCloseModal}
            stockList={stockList}
            selectedStocks={selectedStocks}
            handleSelectStock={handleSelectStock}
            onCloseComplete={() => {
               setTimeout(() => {
                  if (daybook?.isAllowGstRate && company?.setting?.applyGST && daybook?.applyGst) {
                     gstRateRefs.current[currentLineItemIdx]?.focus();
                  } else {
                     rateRefs.current[currentLineItemIdx]?.focus();
                  }
               }, 0);
            }}
         />

         {/* Exchange modal */}
         <ExchangeModal
            isOpen={isOpenExchangeModal}
            onClose={onCloseExchangeModal}
            exchange={exchange}
            data={id && salesInvoice ? editExchangeData : null}
            setExchange={setExchange}
            handleAskToVerifyCustomer={handleAskToVerifyCustomer}
            daybookPaymentData={daybookPaymentData}
            setExchangePayments={setExchangePayments}
            selectedDaybook={selectedDaybook}
         />

         {/* Customer Verify modal  */}
         <CustomerVerifyModal
            isOpen={isOpenVerifyModal}
            onClose={onCloseVerifyModal}
            accountId={row.header.accountId}
            entryData={salesInvoice}
            handleSubmit={handleSubmit}
            mobile={account?.mobile}
            account={account}
            isLoading={isLoading}
            entryType="sales"
            invoiceImages={invoiceImages}
            setInvoiceImages={setInvoiceImages}
         />

         <DeleteDialog
            isDeleteDialogOpen={isOpenDeleteModal}
            setDeleteDialogOpen={onCloseDeleteModal}
            handleDelete={handleDelete}
            title="Delete Line Item"
         />

         {/* Print Format Moal  */}
         <PrintFormat
            isOpen={isOpenPrintFormatModal}
            onClose={onClosePrintFormatModal}
            daybook={daybook}
            functionName="Sales Invoice"
            redirect="/admin/sales/challan"
         />

         <Modal isOpen={isOpenSerialhistory} onClose={onCloseSerialhistory} size="6xl">
            <ModalOverlay />
            <ModalContent>
               <ModalHeader>Serial History({data[0]?.serial_no})</ModalHeader>
               <ModalCloseButton />
               <ModalBody>
                  {data?.length > 0 ? (
                     <Table variant="simple" size="sm">
                        <Thead>
                           <Tr>
                              <Th>Doc No</Th>
                              <Th>Transaction at</Th>
                              <Th>Transaction Type</Th>
                              <Th>Account Name</Th>
                              <Th>Daybook Name</Th>
                              <Th>Item Rate</Th>
                           </Tr>
                        </Thead>
                        <Tbody>
                           {data?.map((data, index) => (
                              <Tr key={index}>
                                 <Td>{data.doc_no}</Td>
                                 <Td>{new Date(data.transaction_at).toLocaleDateString('en-GB')}</Td>
                                 <Td>{data.transaction_type}</Td>
                                 <Td>{data.account_name}</Td>
                                 <Td>{data.daybook_name}</Td>
                                 <Td>{data.item_rate}</Td>
                              </Tr>
                           ))}
                        </Tbody>
                     </Table>
                  ) : (
                     <Text color="gray.500">No transaction history found.</Text>
                  )}
               </ModalBody>
            </ModalContent>
         </Modal>

         <Modal isOpen={isOpenAdjustedDocs} onClose={onCloseAdjustedDocs} size="6xl">
            <ModalOverlay />
            <ModalContent>
               <ModalHeader>Adjusted Docs</ModalHeader>
               <ModalCloseButton />
               <ModalBody>
                  {adjustedDocs?.length > 0 ? (
                     <Table variant="simple" size="sm">
                        <Thead>
                           <Tr>
                              <Th>Doc No</Th>
                              {/* <Th>Transaction at</Th> */}
                              {/* <Th>Transaction Type</Th> */}
                              <Th>Txn Date</Th>
                              <Th>Account Name</Th>
                              <Th>Daybook Name</Th>
                              <Th>Amount</Th>
                           </Tr>
                        </Thead>
                        <Tbody>
                           {adjustedDocs?.map((txn, index) => (
                              <Tr key={index}>
                                 <Td>{txn.adj_docno}</Td>
                                 {/* <Td>{new Date(txn.adj_txnDate).toLocaleDateString('en-GB')}</Td> */}
                                 {/* <Td>{txn.transaction_type}</Td> */}
                                 <Td>{new Date(txn.adj_txnDate).toLocaleDateString('en-GB')}</Td>
                                 <Td>{txn.adj_accountname}</Td>
                                 <Td>
                                    {selectedDaybookData?.length > 0
                                       ? txn.adj_daybookname === selectedDaybookData[0].name
                                          ? txn.daybookname
                                          : txn.adj_daybookname
                                       : txn.adj_daybookname}
                                 </Td>
                                 <Td>{txn.amount}</Td>
                              </Tr>
                           ))}
                        </Tbody>
                     </Table>
                  ) : (
                     <Text color="gray.500">No Adjusted Docs Data found.</Text>
                  )}
               </ModalBody>
            </ModalContent>
         </Modal>

         {(salesData || shouldShowSalesDetails) && (
            <SalesDetails
               salesData={salesData}
               setShouldOpenModalForWpSettings={setShouldOpenModalForWpSettings}
               shouldOpenModalForWpSettings={shouldOpenModalForWpSettings}
            />
         )}

         <TakaForm
            isOpen={isOpenTakaModal}
            onClose={onCloseTakaModal}
            handleTakaDetails={handleTakaDetails}
            currentTakaDetails={currentTakaDetails}
            onCloseComplete={() => {
               setTimeout(() => {
                  rateRefs.current[currentIndex]?.focus();
               }, 0);
            }}
         />

         <SelectTakaDetail
            isOpen={isOpenTakaDetailModal}
            onClose={onCloseTakaDetailModal}
            takaDetails={takaDetails}
            handleSaveTakaDetail={handleSaveTakaDetail}
            selectedTakaDetails={selectedTakaDetails}
            onCloseComplete={() => {
               setTimeout(() => {
                  rateRefs.current[currentIndex]?.focus();
               }, 0);
            }}
            lineItem={row.lineItem}
            currentIndex={currentIndex}
         />
      </>
   );
};

export default SalesInvoiceForm;
